import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { trackError, ActivityTracker } from '../analytics'
import Layout from '../components/Layout'
import AllMerchants from '../pages/merchants/AllMerchants'
import RejectedKYCs from '../pages/merchants/RejectedKYCs'
import KYCAnalytics from '../pages/merchants/KYCAnalytics'
import KycMerchantList from '../pages/merchants/KycMerchantList'
import MerchantUsers from '../pages/users/index'
import ProPilot from '../components/ProshipPilot'
import AllOrder from '../pages/orders/AllOrders'
import Dashboard from '../pages/dashboard/index'
import OpenNdr from '../pages/ndr/OpenNdr'
import NdrScope from '../pages/ndr/NdrScope'
import View from '../pages/orders/OrderDetails'
import Tracking from '../pages/tracking/Tracking'
import Serviceability from '../pages/serviceability/Serviceability'
import ViewC from '../pages/couriers/View'

import UnprocessedOrders from '../pages/orders/UnprocessedOrdersForward'
import Setup from '../pages/couriers/Setup'
import AllReports from '../pages/reporting/AllReports'
import CreateReport from '../pages/reporting/CreateReport'
import Zone from '../pages/zone/Zones'
import UploadFiles from '../pages/uploads/UploadFiles'
import ClosedNdr from '../pages/ndr/ClosedNDR'
import ReverseOrder from '../pages/orders/UnprocessedOrdersReverse'
import Wallet from '../pages/Wallet/Wallet'
import MonthlySmsWaReport from '../pages/Wallet/MonthlySmsWaReport'
import RazorpayMonthlyDump from '../pages/Wallet/RazorpayMonthlyDump'
import AllRVPOrders from '../pages/orders/AllRVPOrders'
import RvpQcSetups from '../pages/admin/rvp-qc/RvpQcSetups'
import RvpQcEditor from '../pages/admin/rvp-qc/RvpQcEditor'
import RvpQcMaster from '../pages/admin/rvp-qc/RvpQcMaster'
import RvpQcHelp from '../pages/admin/rvp-qc/RvpQcHelp'
import CreateKciEvent from '../pages/kci/CreateKciEvent'
import KciDashboard from '../pages/kci/KciDashboard'
import ManageEvents from '../pages/kci/ManageEvents'
import TaggedOrders from '../pages/kci/TaggedOrders'
import NotificationConfig from '../pages/kci/NotificationConfig'
import UpdateOffine from '../pages/Wallet/UpdateOffline'
import CodUpload from '../pages/Wallet/CODUpload'
import UnprocessedOrderView from '../pages/orders/UnprocessOrderView'
/* import CODRemittance from '../pages/Wallet/CODRemittance' */
import B2Bupload from '../pages/B2BOrder/B2bUpload'
import B2BOrderSummary from '../pages/B2BOrder/B2BOrderSummary'
import EddBreachAttribution from '../pages/ptl-edd-breach/EddBreachAttribution'
import PtlTeamMaster from '../pages/ptl-edd-breach/TeamMaster'
import PtlBillingOverview from '../pages/ptl-billing/BillingOverview'
import PtlBillingTerms from '../pages/ptl-billing/BillingTerms'
import PtlAdhocCharges from '../pages/ptl-billing/AdhocCharges'
import PtlBillingReview from '../pages/ptl-billing/BillingReview'
import PtlBillingFiles from '../pages/ptl-billing/BillingFiles'
import PodAnalytics from '../pages/pod-analytics/PodAnalytics'
import ShopifyEddLocation from '../pages/shopify-edd-location/ShopifyEddLocation'
import PtlOnboardingHealth from '../pages/ptl-merchant-setup/PtlOnboardingHealth'
import PtlOnboardingStep from '../pages/ptl-merchant-setup/PtlOnboardingStep'
import PtlMerchantUpdate from '../pages/ptl-merchant-setup/PtlMerchantUpdate'
import PtlMerchantHub from '../pages/ptl-merchant-setup/PtlMerchantHub'
import PtlZoneOverrides from '../pages/ptl-merchant-setup/PtlZoneOverrides'
import PtlZoneOverrideMerchant from '../pages/ptl-merchant-setup/PtlZoneOverrideMerchant'
import PtlZoneMapStandard from '../pages/ptl-merchant-setup/PtlZoneMapStandard'
import PtlUploadScreen from '../pages/ptl-merchant-setup/screens/UploadScreen'
import PtlHistoryScreen from '../pages/ptl-merchant-setup/screens/HistoryScreen'
import PtlTatCustom from '../pages/ptl-merchant-setup/PtlTatCustom'
import PtlTatCustomMerchant from '../pages/ptl-merchant-setup/PtlTatCustomMerchant'
import PtlTatStandard from '../pages/ptl-merchant-setup/PtlTatStandard'
import PtlTatCourier from '../pages/ptl-merchant-setup/PtlTatCourier'
import PtlTatCourierLanes from '../pages/ptl-merchant-setup/PtlTatCourierLanes'
import PtlOdaPincodes from '../pages/ptl-oda/PtlOdaPincodes'
import PtlOdaBands from '../pages/ptl-oda/PtlOdaBands'
import PtlOdaHistory from '../pages/ptl-oda/PtlOdaHistory'
import PtlOdaShipments from '../pages/ptl-oda/PtlOdaShipments'
import { PTL_EDD_ADMIN_ACCESS } from "../pages/ptl-edd-breach/constants";
import WeightFreezeUpload from '../pages/WeightFreeze/WeightFreezeUpload'
import OpenShipment from '../pages/B2BOrder/OpenShipment'
import RateCard from '../pages/couriers/RateCard'
import BulkManualstatus from '../pages/orders/BulkManualstatus'
import InvoiceLabel from '../pages/serviceability/InvoiceLabel'
import PodsUploads from '../pages/uploads/POdsUploads'
import axios from 'axios'
import ProtectedRoute, { MultiRoleProtectedRoute } from './ProtectedRoute'
import store from '../redux/store'
import { logout, updateToken } from '../redux/userSlice'
import { clearSessionAndRedirect } from '../helpers/sessionHelper'
import { apiConstants } from '../common/constants'
/* import UnAuthorized from "./UnAuthorized"; */
import InvoiceUpload from '../pages/uploads/InvoiceUpload'
import BulkImageUpload from '../pages/Weight Discrepancy/BulkImageUpload'
import AllDiscrepancy from '../pages/Weight Discrepancy/AllDiscrepancy'
import CODReconcilation from '../pages/Wallet/CODReconcilation'
import WebHooks from '../pages/WebHooks/Webhooks'
import ShippingLabel from '../pages/WebHooks/ShippingLabel'
import ChannelOrder from '../pages/ChannelOrder/ChannelOrder'
import ViewDetails from '../pages/ChannelOrder/ViewDetails'
import MerchantInvoice from '../pages/Wallet/MerchantInvoice'
import BulkCancellation from '../pages/WebHooks/BulkCancelllation'
import MerchantPriceMissing from '../pages/serviceability/MerchantPricingMissing'
import CourierPriceMissing from '../pages/serviceability/CourierPricingMissing'
import RemittanceForAllMerchant from '../pages/cod/RemittanceForAllMerchant'
import UpdatedEdd from '../pages/orders/UpdateEdd'
import EddUploads from '../pages/uploads/EddUploads'
import CancellationPending from '../pages/orders/CancellationPending'
import MerchantConfig from '../pages/WebHooks/MerchantConfig'
import CourierMISUpload from '../pages/Weight Discrepancy/CourierMISUpload'
import RefreshUrl from '../pages/WebHooks/RefreshUrl'
import ResetTerminalStatus from '../pages/orders/ResetTerminalStatus'
import UploadFileRef from '../pages/WebHooks/UploadFileRef'
import ProductMaster from '../pages/merchants/ProductMaster'
import CalculateRate from '../pages/serviceability/CalculateRate'
import DefaultPricing from '../pages/merchants/DefaultPricing'
import MerchantPricingWizard from '../pages/merchants/pricing-wizard/MerchantPricingWizard'
import MerchantListing from '../pages/merchants/pricing-wizard/MerchantListing'
import MerchantsAllListing from '../pages/merchants/pricing-wizard/MerchantsAllListing'
import MerchantTatWizard from '../pages/merchants/tat-wizard/MerchantTatWizard'
import D2CAllocation from '../pages/merchants/d2c-allocation/D2CAllocation'
// ── D2C Freight Pricing Agent (new module) ─────────────────────────────────
import D2CPSLDashboard from '../pages/d2c-pricing-agent/sl/SLDashboard'
import D2CPSLApprovalQueue from '../pages/d2c-pricing-agent/sl/SLApprovalQueue'
import D2CPSLHistory from '../pages/d2c-pricing-agent/sl/SLHistory'
import D2CPSLCounterReview from '../pages/d2c-pricing-agent/sl/SLCounterReview'
import D2CPNewProposal from '../pages/d2c-pricing-agent/shared/NewProposal'
import D2CPLanding from '../pages/d2c-pricing-agent/shared/D2CLanding'
import PiiRequests from '../pages/pii-requests/PiiRequests'
import D2CPGTMToolkit from '../pages/d2c-pricing-agent/shared/GTMToolkit'
import D2CPGuide from '../pages/d2c-pricing-agent/shared/TaxonomyGuide'
import D2CPL1Dashboard from '../pages/d2c-pricing-agent/l1/L1Dashboard'
import D2CPL1ApprovalQueue from '../pages/d2c-pricing-agent/l1/L1ApprovalQueue'
import D2CPL1DealReview from '../pages/d2c-pricing-agent/l1/L1DealReview'
import D2CPL1History from '../pages/d2c-pricing-agent/l1/L1History'
import D2CPFHDashboard from '../pages/d2c-pricing-agent/fh/FHDashboard'
import D2CPFHApprovalQueue from '../pages/d2c-pricing-agent/fh/FHApprovalQueue'
import D2CPFHDealReview from '../pages/d2c-pricing-agent/fh/FHDealReview'
import D2CPFHHistory from '../pages/d2c-pricing-agent/fh/FHHistory'
import D2CPFHRules from '../pages/d2c-pricing-agent/fh/FHRules'
import D2CPFHMasters from '../pages/d2c-pricing-agent/fh/FHMasters'
import { D2C_ROLE_GATING } from '../pages/d2c-pricing-agent/constants'
// ── GrowthOS migration — Brands master data (day-one slice) ───────────────
import GrowthOsBrandsPage from '../pages/growthos-brands/BrandsPage'
import { GROWTHOS_ROLE_GATING } from '../pages/growthos-brands/constants'
import GrowthOsBudgetPage from '../pages/growthos-budget/BudgetPage'
import GrowthOsPocsPage from '../pages/growthos-pocs/PocsPage'
import SalesPocDashboardPage from '../pages/growthos-poc-analytics/SalesPocDashboardPage'
import SalesPocIndividualPage from '../pages/growthos-poc-analytics/SalesPocIndividualPage'
import GrowthOsConnectorsPage from '../pages/growthos-connectors/ConnectorsPage'
import GrowthOsRetentionPage from '../pages/growthos-retention/RetentionPage'
import SmePerformancePage from '../pages/growthos-sme/SmePerformancePage'
import ExecutivePage from '../pages/growthos-executive/ExecutivePage'
import DecisionInsightsPage from '../pages/growthos-decision-insights/DecisionInsightsPage'
import MarketingFunnelPage from '../pages/growthos-marketing-funnel/MarketingFunnelPage'
import PipelineFunnelPage from '../pages/growthos-pipeline-funnel/PipelineFunnelPage'
import EmailMarketingPage from '../pages/growthos-email-marketing/EmailMarketingPage'
import LinkedinAbmPage from '../pages/growthos-linkedin-abm/LinkedinAbmPage'
import HubspotReviewPage from '../pages/growthos-hubspot-review/HubspotReviewPage'
import LeadershipDashboard from '../pages/leadership/index'
import OrderAllocationAnalytics from '../pages/allocation-analytics/OrderAllocationAnalytics'
import Step1_SetupKYC from '../pages/merchants/onboarding/Step1_SetupKYC'
import UpdateMerchantName from '../pages/WebHooks/UpdateMerchantName'
import ChannelConfig from '../pages/WebHooks/ChannelConfig'
import NotificationAudit from '../pages/WebHooks/NotificationAudit'
import Upload from '../pages/WebHooks/Upload'
import Cache from '../pages/WebHooks/Cache'
import Invoice from '../pages/Wallet/Invoice'
import MerchantInvoiceCorrections from '../pages/Wallet/MerchantInvoiceCorrections'
import CourierInvoice from '../pages/Wallet/CourierInvoice'
import WeightDiscrepancyBulkAction from '../pages/Weight Discrepancy/Index'
import PtlPickupRequests from '../pages/B2BOrder/PickupRequests'
import ShipmentRateCalculatorPTL from '../components/shipment-calculator-ptl'
import AllCourierTabs from '../pages/couriers/AllCourierTabs'
import PickupRequestDetails from '../pages/B2BOrder/PickupRequestDetails'
import CreatePickupRequest from '../pages/B2BOrder/CreatePickupReq'
import B2bUploadV2 from '../pages/B2BOrder/B2bUploadV2'
import B2BUploadAdditionalCharges from '../pages/B2BOrder/B2BUploadAdditionalCharges'
import MerchantTransaction from '../pages/Wallet/MerchantTransactionTabs'
import WAAutomation from '../pages/ndr/WAAutomation'
import { MerchantLocations } from '../components/locations'
import BulkTracking from '../components/BulkTracking'
import ListTracking from '../components/tracking/list'
import CopyZone from '../pages/WebHooks/CopyZone'
import CreditNoteList from '../pages/CreditNote/CreditNoteList'
import NDRBulkUpload from '../pages/ndr/NDRBulkUpload'
import NDRCall from '../pages/ndr/NdrCalls'
// import CreditNoteFinanceList from '../pages/Wallet/CreditNoteFinance'
import MerchantCNUpload from '../pages/Wallet/MerchantCNUpload'
import InvoiceDetails from '../pages/Wallet/InvoiceDetails'
import WhatsAppNDR from '../pages/ndr/WhatsappNDR'
import SYConfig from '../pages/WebHooks/SYConfig'
import { MerchantDeliveryLocations } from '../components/locations/DeliveryLocation'
import CourierStatusMap from '../components/CourierStatusMap'
import LostAndDamage from '../pages/Lost and Damage/LostAndDamage'
import FinanceLostDamage from '../pages/Lost and Damage/FinanceLostDamage'
import AutomatedRuleUpload from '../pages/uploads/AutomatedRuleUpload'
import CourierCodReconTabs from '../pages/Courier COD Recon'
import EscalationManagement from '../components/EscalationManagement/index'
import ViewEms from '../components/EscalationManagement/ViewEms'
import { EMS_V2_ENABLED, ESCALATION_HOME } from './emsV2Visibility'
import EscalationManagementV2 from '../components/EscalationManagementV2/index'
import EscalationViewTicketV2 from '../components/EscalationManagementV2/ViewTicket'
import EscalationAnalyticsV2 from '../components/EscalationManagementV2/AnalyticsPage'
import EscalationEmailSettingsV2 from '../components/EscalationManagementV2/EmailSettingsPage'
import EscalationCategoriesV2 from '../components/EscalationManagementV2/CategoriesPage'
import EscalationReportSchedulesV2 from '../components/EscalationManagementV2/ReportSchedulesPage'
import AllShipmentsDetails from '../pages/OrderAnalytics/AllShipments'
import Analytics from '../pages/OrderAnalytics/Analytics'
import AppointmentDeliveries from '../pages/B2BOrder/AppointmentDeliveries'
import AppointmentsAll from '../pages/AppointmentDeliveriesV2/AllAppointments'
import AppointmentsMissedRepeat from '../pages/AppointmentDeliveriesV2/MissedRepeat'
import AppointmentsNeedsAction from '../pages/AppointmentDeliveriesV2/NeedsAction'
import AppointmentsAbdTagging from '../pages/AppointmentDeliveriesV2/ABDConsigneeTagging'
import AppointmentsAnalytics from '../pages/AppointmentDeliveriesV2/ReportsAnalytics'
import AppointmentsBulkUpload from '../pages/AppointmentDeliveriesV2/BulkUpload'
import AppointmentsMissReasons from '../pages/AppointmentDeliveriesV2/MissReasonSettings'
import AppointmentsEdited from '../pages/AppointmentDeliveriesV2/EditedAppointments'
import AppointmentsOverdue from '../pages/AppointmentDeliveriesV2/OverdueAppointments'
import ReasonMasterSettings from '../pages/ReasonMaster/ReasonMasterSettings'
import NetraIntelligenceDashboard from '../pages/netra/NetraIntelligenceDashboard'
import B2bCreateUpload from '../pages/B2BOrder/B2bCreateUpload'
import UnderProcessOrders from '../pages/B2BOrder/UnderProcessOrders'
import DwsConfig from '../components/DwsConfig'
import DwsWeightUpload from '../pages/Weight Discrepancy/DwsWeightUpload'
import WeightLedger from '../pages/WeightLedger/Index'
import PredictedWeightPage from '../pages/WeightLedger/PredictedWeightPage'
import ExactMatchShipmentsPage from '../pages/WeightLedger/ExactMatchShipmentsPage'
import WeightV2Disputes from '../pages/WeightV2/DisputesPage'
import WeightV2FreezeRequests from '../pages/WeightV2/FreezeRequestsPage'
import WeightV2Settings from '../pages/WeightV2/SettingsPage'
import QcConfig from '../components/QcConfig'
import CourierConfiguration from '../components/CourierConfiguration'
import BulkBlockedPincodes from '../pages/BulkBlockedPincodes/BulkBlockedPincodes'
import MerchantCreditLimits from '../pages/merchants/MerchantCreditLimit'
import Notification from '../components/Notifications'
import OpenNpr from '../pages/npr/OpenNpr'
import ClosedNpr from '../pages/npr/ClosedNPR'
import NPRCall from '../pages/npr/NprCalls'
import NPRBulkUpload from '../pages/npr/NPRBulkUpload'
import UploadImages from '../pages/Weight Discrepancy/UploadImages'
import UpdateOrderHistory from '../pages/uploads/UpdateOrderHistory'
import Config from '../pages/Config/index'
import TrackingPageAdmin from '../pages/Config/TrackingPageAdmin'
import UserManagementPanel from '../components/UserManagement'
import RefreshWallet from '../pages/WebHooks/ResetWallet'
import CODConfigurationTabs from '../pages/merchants/CodConfigTabs'
import SMSWAInvoicing from '../pages/Invoicing SMS WA'
import ClickPostLogs from '../pages/Clickpost Logs'
import PaymentDetails from '../pages/Wallet/PaymentDetails'
import MerchantDetailTabs from '../pages/merchants/merchant details'
import CourierAllocationPicker from '../pages/merchants/CourierAllocationPicker'
// import UpdateB2COrder from "../pages/orders/UpdateB2COrder";
import WeightFreezeDetails from '../pages/WeightFreeze/SKUUpdate'
import InsuranceConfig from '../pages/Insurance Config/addConfig'
import InsuranceListTabs from '../pages/Insurance Config'
import DonwloadMISfromAWB from '../pages/AWBbasedMIS'
import SorterImage from '../components/SorterImages'
import ManualStatusUpdate from '../pages/orders/ManualStatusUpdate'
import AwbEddDetails from '../components/AwbEddDetails'
import QcClickPost from '../components/QCClickpostMapping'
import CreateQuickPickupRequest from '../pages/B2BOrder/QuickPickupRequest'
import ReactGA from 'react-ga4'

import { GoogleAnalytics } from '../components/google-analytics'
import BulkDownloadPOD from '../pages/BulkDownloadPOD'
import BulkDownloadLabelsB2C from '../pages/BulkDownloadLabelsInvoice/B2cLabels'
import BulkDownloadLabelsB2B from '../pages/BulkDownloadLabelsInvoice/B2bLabels'
import BulkDownloadInvoice from '../pages/BulkDownloadLabelsInvoice/BulkInvoiceDownload'
import LabelTabs from '../pages/LabelTabs'
import MerchantWallet from '../pages/merchants/MerchantWallet'
import ZoneOverRide from '../pages/WebHooks/ZoneOverride'
import WeightZoneRulesBuilder from '../pages/uploads/WeightZoneRulesBuilder'
import UserLevelPiiAccess from '../components/UserManagement/UserLevelPiiAccess'
import PendingCODRemittance from '../pages/AxisBankIntegration/PendingCODRemittance'
import BeneficiaryDetails from '../pages/AxisBankIntegration/BeneficiaryMaster'
import BeneficiaryApproval from '../pages/AxisBankIntegration/BeneficiaryApproval'
import CloseCODRemittance from '../pages/AxisBankIntegration/CloseCODRemittance'
import HolidayList from '../pages/uploads/HolidayList'
import CODRemittanceTabs from '../pages/Wallet/CODRemittanceTabs'
import ShadowRunPage from '../pages/AllocationConfig/ShadowRunPage'
import BusinessKnobsPage from '../pages/AllocationConfig/BusinessKnobsPage'
import ExternalShadowRunPage from '../pages/AllocationConfig/ExternalShadowRunPage'
import ServiceTypesPage from '../pages/AllocationConfig/ServiceTypesPage'
import PaceAnalyticsPage from '../pages/AllocationConfig/PaceAnalyticsPage'
import PaceAboutPage from '../pages/PaceAbout/PaceAboutPage'
import IntelligentEDD from '../pages/IntelligentEDD'
import BulkServiceability from '../pages/bulk_serviceability/BulkServiceability'
import PaceAnalytics from '../pages/pace_analytics/PaceAnalytics'
import PaceMerchantList from '../pages/pace_merchant_list/PaceMerchantList'
import PaceV2MerchantList from '../pages/pace_v2_merchant_list/PaceV2MerchantList'
import PaceShipmentCounts from '../pages/pace_shipment_counts/PaceShipmentCounts'
import { CourierPerformance } from '../pages/courierPerformance'

import AuditTrails from '../pages/audit/AuditTrails'
import Home from '../pages/home'
import AllClaims from '../pages/Claims/AllClaims'
import ClaimDetail from '../pages/Claims/ClaimDetail'
import RateCardHistory from '../pages/tools/RateCardHistory'
import OrderCreationLatency from '../pages/tools/OrderCreationLatency'
import QcMonitor from '../pages/tools/QcMonitor'
// Data Archival (Utilities & Tools › Admin Actions) — tiered Mongo log archival (ROLE_PROSHIPADMIN; backend /api/tools/archive/collections)
import DataArchival from '../pages/DataArchival'
// ProShip Direct — plan management (ROLE_PROSHIPADMIN only; backend /api/direct/admin)
import { DIRECT_ROLE_GATING } from '../pages/direct/constants'
import DirectPlanCatalog from '../pages/direct/PlanCatalog'
import DirectOffers from '../pages/direct/Offers'
import DirectSubscriptions from '../pages/direct/Subscriptions'
import DirectSubscriptionDetail from '../pages/direct/SubscriptionDetail'
import DirectDefaultAccounts from '../pages/direct/DefaultAccounts'
import IntelTrendsOverview from '../pages/serviceability_intel/TrendsOverview'
import IntelCoverageDelivery from '../pages/serviceability_intel/CoverageDelivery'
import IntelCoveragePickup from '../pages/serviceability_intel/CoveragePickup'
import IntelCoverageUploads from '../pages/serviceability_intel/CoverageUploads'
import IntelWeightSlabs from '../pages/serviceability_intel/WeightSlabs'
import IntelSetupGroups from '../pages/serviceability_intel/SetupGroups'
import IntelServiceTypeTaxonomy from '../pages/serviceability_intel/ServiceTypeTaxonomy'
import IntelServiceTypeGuide from '../pages/serviceability_intel/ServiceTypeGuide'
import IntelBulkServiceability from '../pages/serviceability_intel/BulkServiceabilityIntel'
import IntelBlockNew from '../pages/serviceability_intel/BlockNew'
import IntelBlockActive from '../pages/serviceability_intel/BlockActive'
import ReleaseNotes from '../pages/ReleaseNotes'
import ReleaseNoteDetail from '../pages/ReleaseNotes/Detail'
import IntelServiceTypePerformance from '../pages/serviceability_intel/ServiceTypePerformance'
import IntelBlockRto from '../pages/serviceability_intel/BlockRto'
import IntelStuckOrders from '../pages/serviceability_intel/StuckOrders'
import IntelDashboard from '../pages/serviceability_intel/Dashboard'
import IntelNonServiceable from '../pages/serviceability_intel/NonServiceable'
import IntelCoverageAnalysis from '../pages/serviceability_intel/CoverageAnalysis'
import IntelStuckTrends from '../pages/serviceability_intel/StuckTrends'

// ===================== Intervention Analytics module (/intervention/*) =====
import InterventionLayout from '../pages/intervention-analytics/InterventionLayout'
import InterventionDashboard from '../pages/intervention-analytics/m0-dashboard/InterventionDashboard'
import CallAnalytics from '../pages/intervention-analytics/m1-calls/CallAnalytics'
import CallRecordings from '../pages/intervention-analytics/m1-calls/CallRecordings'
import WhatsappAnalytics from '../pages/intervention-analytics/m2-whatsapp/WhatsappAnalytics'
import TemplateRegistry from '../pages/intervention-analytics/m3-templates/TemplateRegistry'
import RuleDashboard from '../pages/intervention-analytics/m4-rules/RuleDashboard'
import CostAnalytics from '../pages/intervention-analytics/m5-cost/CostAnalytics'
import NdrDrilldown from '../pages/intervention-analytics/m6-drilldown/NdrDrilldown'
import NprDrilldown from '../pages/intervention-analytics/m6-drilldown/NprDrilldown'

// ===================== Supply-Side module (/supply/*) =====================
import SupplySideLayout from '../pages/supply-side/SupplySideLayout'
import PartnerDirectory from '../pages/supply-side/m0-partners/PartnerDirectory'
import Partner360 from '../pages/supply-side/m0-partners/Partner360'
import OnboardWizard from '../pages/supply-side/m0-onboard/OnboardWizard'
import PcisDashboard from '../pages/supply-side/m5-pcis-health/dashboard/PcisDashboard'
import PcisHealthSummary from '../pages/supply-side/m5-pcis-health/PcisHealthSummary'
import PcisHealthDetails from '../pages/supply-side/m5-pcis-health/PcisHealthDetails'
import PcisHealthManage from '../pages/supply-side/m5-pcis-health/PcisHealthManage'
import PcisStatusMapping from '../pages/supply-side/m5-pcis-health/PcisStatusMapping'
import PcisCacheManage from '../pages/supply-side/m5-pcis-health/PcisCacheManage'
import PcisBlueDartOriginArea from '../pages/supply-side/m5-pcis-health/PcisBlueDartOriginArea'
import PcisErrorMapping from '../pages/supply-side/m5-pcis-health/PcisErrorMapping'
import PcisServiceability from '../pages/supply-side/m5-pcis-health/PcisServiceability'
import UpdateWizard from '../pages/supply-side/m0-update/UpdateWizard'
import SupplyAgreements from '../pages/supply-side/m2-agreements/Agreements'
import SupplyRateCards from '../pages/supply-side/m3-ratecards/RateCards'
import SupplyZoneMapper from '../pages/supply-side/m4-zones/ZoneMapper'
import SupplyZoneOverride from '../pages/supply-side/m4-zones/ZoneOverride'
import SupplyInvoiceRecon from '../pages/supply-side/m5-invoice/InvoiceRecon'
import SupplyPayments from '../pages/supply-side/m5-invoice/Payments'
import SupplyCodRecon from '../pages/supply-side/m6-cod/CodRecon'
import SupplyOvercharge from '../pages/supply-side/m7-overcharge/Overcharge'
import SupplyDashboards from '../pages/supply-side/m1-dashboards/Dashboards'
import PtlPlaceholder from '../pages/supply-side/m1-dashboards/PtlPlaceholder'
import ClickpostSetup from '../pages/supply-side/m0-credentials/ClickpostSetup'
import CourierCodesMaster from '../pages/supply-side/m1-codes/CourierCodesMaster'
import PaymentModeCompliance from '../pages/supply-side/m1-codes/PaymentModeCompliance'
import CourierCodeDeepDive from '../pages/supply-side/m0-partners/CourierCodeDeepDive'
// Freight Profitability (Reports & Analytics) — replaces the Control Tower org-level freight P&L mails.
import FreightProfitability from '../pages/freight-profitability/FreightProfitability'
// Stuck Shipments (Reports & Analytics) — replaces the Control Tower "Daily Alert – D2C/PTL Stuck Shipments" mails.
import StuckShipments from '../pages/stuck-shipments/StuckShipments'
// Internal Alerts (Reports & Analytics) — view/health of the internal WhatsApp alerts Control Tower + Proship send to staff.
import InternalAlerts from '../pages/internal-alerts/InternalAlerts'
// Merchant Setup › Zone Mapping — new pages on the legacy merchant-zone APIs (tools/listzone,
// config/merchant/{id}/zones, tools/upload/servicability). Legacy routes below stay untouched.
import ZoneLookup from '../pages/merchant-zones/ZoneLookup'
import MerchantZoneOverride from '../pages/merchant-zones/MerchantZoneOverride'
import MerchantZoneBaseUpload from '../pages/merchant-zones/MerchantZoneBaseUpload'


// Component for conditional redirect based on user access
function ConditionalRedirect() {
  try {
    return <Navigate to='/home' />
  } catch (error) {
    console.warn('Error checking user access in PrivateRoute, defaulting to home:', error)
    return <Navigate to='/home' />
  }
}

ReactGA.initialize(process.env.REACT_APP_GA_ID)

axios.interceptors.request.use(
  (config) => {
    const {
      user: {
        userInfo: { accessToken },
      },
    } = store.getState()

    // if (accessToken && !config.headers.clickPostLogs) {
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  (err) => Promise.reject(err)
)

let refreshPromise = null

axios.interceptors.response.use(
  (response) => response,
  async (err) => {
    const failedUrl = err.config?.url || ''
    if (!err.response && err.request && !failedUrl.includes('usage-analytics')) { trackError(err) }
    const msg = err?.response?.data?.message?.toLowerCase() || ''

    // Session killed server-side — the user logged out (possibly in another tab), an admin ran
    // logout-all, or their password changed. Refreshing is pointless: /auth/refreshtoken would
    // be rejected too, since logout drops the refresh session along with the access token. Bail
    // straight to login instead of letting a 401 surface as a broken page.
    const isRevoked = err?.response?.status === 401 && msg.includes('session expired')
    if (isRevoked) {
      clearSessionAndRedirect()
      return Promise.reject(err)
    }

    const isExpired = err?.response?.status === 401 && (msg.includes('jwt') && (msg.includes('expired') || msg.includes('token is expired')))
    if (isExpired && !err.config?._retry) {
      err.config._retry = true
      const refreshToken = localStorage.getItem('refreshToken')
      if (!refreshToken) {
        store.dispatch(logout())
        store.dispatch({ type: 'USER_LOGGED_OUT' })
        return Promise.reject(err)
      }
      try {
        if (!refreshPromise) {
          refreshPromise = axios
            .post(`${apiConstants.BASE_LOCAL}auth/refreshtoken`, { refreshToken, panel: 'ADMIN' })
            .finally(() => { refreshPromise = null })
        }
        const res = await refreshPromise
        const newAccessToken = res.data.accessToken
        const newRefreshToken = res.data.refreshToken
        localStorage.setItem('userToken', newAccessToken)
        if (newRefreshToken) localStorage.setItem('refreshToken', newRefreshToken)
        store.dispatch(updateToken(newAccessToken))
        err.config.headers.Authorization = `Bearer ${newAccessToken}`
        return axios(err.config)
      } catch {
        store.dispatch(logout())          // clears localStorage + user slice
        store.dispatch({ type: 'USER_LOGGED_OUT' }) // resets all other slices
      }
    }
    return Promise.reject(err)
  }
)

// D2C route guards honour the D2C_ROLE_GATING flag (constants.js). When false
// (⚠️ TEMP testing bypass — backend not issuing PROPOSAL_* flags yet) the element
// renders unguarded; when true it enforces the real per-role access.
const D2C_ALL = ['PROPOSAL_CREATE', 'PROPOSAL_L1', 'PROPOSAL_ADMIN']
const D2CGuard = ({ role, children }) => (D2C_ROLE_GATING ? <ProtectedRoute role={role}>{children}</ProtectedRoute> : children)
const D2CMultiGuard = ({ children }) => (D2C_ROLE_GATING ? <MultiRoleProtectedRoute role={D2C_ALL}>{children}</MultiRoleProtectedRoute> : children)

// GrowthOS migration guard — same "ship UI ahead of backend rollout" pattern as
// D2CGuard: open to any logged-in user while GROWTHOS_ROLE_GATING is false.
const GrowthOsGuard = ({ role, children }) => (GROWTHOS_ROLE_GATING ? <ProtectedRoute role={role}>{children}</ProtectedRoute> : children)

export default function PrivateRoutes() {

  return (
    <>
      <GoogleAnalytics />
      <ActivityTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path='auth/*' element={<ConditionalRedirect />} />
          <Route path='google/redirect_uri/*' element={<ConditionalRedirect />} />
          <Route exact element={<Navigate to={'auth/*'} />} path='/forgot-password' />

          {/* ===================== Dashboard ===================== */}
          <Route
            path='dashboard/d2c'
            element={
              <ProtectedRoute role='DASHBOARD'>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path='dashboard/B2C' element={<Navigate to='/dashboard/d2c' replace />} />
          <Route
            path='dashboard/ptl'
            element={
              <ProtectedRoute role='DASHBOARD'>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path='dashboard/B2B' element={<Navigate to='/dashboard/ptl' replace />} />

          {/* ===================== Leadership Dashboard ===================== */}
          {/* Admins (JWT role) see everything; SALES_DASHBOARD module holders
              (KAM/SAM/SL) see only merchants their salesMapping names — the
              backend scopes the data, this route just mirrors both entries. */}
          <Route
            path='leadership/dashboard'
            element={
              <MultiRoleProtectedRoute role={['ROLE_PROSHIPADMIN', 'SALES_DASHBOARD']}>
                <LeadershipDashboard />
              </MultiRoleProtectedRoute>
            }
          />

          {/* Daily Allocation dashboard (TASK-008) — admin-only, mirrors the
              backend gate on /api/allocation/dashboard/summary. */}
          <Route
            path='analytics/order-allocation'
            element={
              <MultiRoleProtectedRoute role={['ROLE_PROSHIPADMIN']}>
                <OrderAllocationAnalytics />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== Home ===================== */}
          <Route path='home' element={<Home />} />

          {/* ===================== ProPilot AI ===================== */}
          <Route
            path='propilot'
            element={
              <ProtectedRoute role='TOOLS'>
                <ProPilot />
              </ProtectedRoute>
            }
          />

          {/* ===================== D2C Section - Orders ===================== */}
          <Route
            path='d2c/orders/forward'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <AllOrder />
              </ProtectedRoute>
            }
          />
          <Route path='orders' element={<Navigate to='/d2c/orders/forward' replace />} />

          <Route
            path='d2c/orders/reverse'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <AllRVPOrders />
              </ProtectedRoute>
            }
          />
          <Route path='reverse-orders' element={<Navigate to='/d2c/orders/reverse' replace />} />

          <Route
            path='d2c/orders/channel'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <ChannelOrder />
              </ProtectedRoute>
            }
          />
          <Route path='channel-orders' element={<Navigate to='/d2c/orders/channel' replace />} />

          <Route
            path='d2c/orders/channel-detail/:id'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <ViewDetails />
              </ProtectedRoute>
            }
          />
          <Route path='channel-order-detail/:id' element={<ProtectedRoute role='B2C_ACCESS'><ViewDetails /></ProtectedRoute>} />

          <Route
            path='d2c/orders/unprocessed-forward'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <UnprocessedOrders />
              </ProtectedRoute>
            }
          />
          <Route path='unprocessed-orders-forward' element={<Navigate to='/d2c/orders/unprocessed-forward' replace />} />

          <Route
            path='d2c/orders/unprocessed-reverse'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <ReverseOrder />
              </ProtectedRoute>
            }
          />
          <Route path='unprocessed-orders-reverse' element={<Navigate to='/d2c/orders/unprocessed-reverse' replace />} />

          <Route
            path='d2c/orders/unprocessed-detail/:id/:key'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <UnprocessedOrderView />
              </ProtectedRoute>
            }
          />
          <Route path='unprocessedorder-detail/:id/:key' element={<ProtectedRoute role='B2C_ACCESS'><UnprocessedOrderView /></ProtectedRoute>} />

          {/* ===================== D2C Section - Operations ===================== */}
          <Route
            path='d2c/operations/cancellation-pending'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <CancellationPending />
              </ProtectedRoute>
            }
          />
          <Route path='cancellation-pending-orders' element={<Navigate to='/d2c/operations/cancellation-pending' replace />} />

          <Route path='manual-status-update' element={<Navigate to='/d2c/operations/manual-status-update' replace />} />

          <Route
            path='d2c/operations/bulk-tracking'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <BulkTracking />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-tracking' element={<Navigate to='/d2c/operations/bulk-tracking' replace />} />

          {/* ===================== D2C Section - Downloads ===================== */}
          <Route
            path='d2c/downloads/labels'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <BulkDownloadLabelsB2C />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-download-labels-b2c' element={<Navigate to='/d2c/downloads/labels' replace />} />

          <Route
            path='d2c/downloads/invoice'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <BulkDownloadInvoice />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-download-invoice' element={<Navigate to='/d2c/downloads/invoice' replace />} />

          {/* ===================== NDR/NPR - NDR ===================== */}
          <Route
            path='ndr-npr/ndr/open'
            element={
              <ProtectedRoute role='NDR'>
                <OpenNdr />
              </ProtectedRoute>
            }
          />
          <Route
            path='ndr-npr/ndr/scope'
            element={
              <ProtectedRoute role='NDR'>
                <NdrScope />
              </ProtectedRoute>
            }
          />
          <Route path='pending-ndr' element={<Navigate to='/ndr-npr/ndr/open' replace />} />

          <Route
            path='ndr-npr/ndr/closed'
            element={
              <ProtectedRoute role='NDR'>
                <ClosedNdr />
              </ProtectedRoute>
            }
          />
          <Route path='closed-ndr' element={<Navigate to='/ndr-npr/ndr/closed' replace />} />

          <Route
            path='ndr-npr/ndr/bulk-upload'
            element={
              <ProtectedRoute role='NDR'>
                <NDRBulkUpload />
              </ProtectedRoute>
            }
          />
          <Route path='ndr-bulk-upload' element={<Navigate to='/ndr-npr/ndr/bulk-upload' replace />} />

          <Route
            path='ndr-npr/ndr/calls'
            element={
              <ProtectedRoute role='NDR'>
                <NDRCall />
              </ProtectedRoute>
            }
          />
          <Route path='ndr-calls' element={<Navigate to='/ndr-npr/ndr/calls' replace />} />

          <Route
            path='ndr-npr/ndr/whatsapp'
            element={
              <ProtectedRoute role='NDR'>
                <WhatsAppNDR />
              </ProtectedRoute>
            }
          />
          <Route path='wa-automation' element={<Navigate to='/ndr-npr/ndr/whatsapp' replace />} />

          {/* ndr-wa-automation was a separate route pointing to WAAutomation - redirect to same new path */}
          <Route
            path='ndr-wa-automation'
            element={
              <ProtectedRoute role='NDR'>
                <WAAutomation />
              </ProtectedRoute>
            }
          />

          {/* ===================== NDR/NPR - NPR ===================== */}
          <Route
            path='ndr-npr/npr/open'
            element={
              <ProtectedRoute role='NDR'>
                <OpenNpr />
              </ProtectedRoute>
            }
          />
          <Route path='pending-npr' element={<Navigate to='/ndr-npr/npr/open' replace />} />

          <Route
            path='ndr-npr/npr/closed'
            element={
              <ProtectedRoute role='NDR'>
                <ClosedNpr />
              </ProtectedRoute>
            }
          />
          <Route path='closed-npr' element={<Navigate to='/ndr-npr/npr/closed' replace />} />

          <Route
            path='ndr-npr/npr/bulk-upload'
            element={
              <ProtectedRoute role='NDR'>
                <NPRBulkUpload />
              </ProtectedRoute>
            }
          />
          <Route path='npr-bulk-upload' element={<Navigate to='/ndr-npr/npr/bulk-upload' replace />} />

          <Route
            path='ndr-npr/npr/calls'
            element={
              <ProtectedRoute role='NDR'>
                <NPRCall />
              </ProtectedRoute>
            }
          />
          <Route path='npr-calls' element={<Navigate to='/ndr-npr/npr/calls' replace />} />

          {/* ===================== PTL - Pickups ===================== */}
          <Route
            path='ptl/pickups/quick'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <CreateQuickPickupRequest />
              </ProtectedRoute>
            }
          />
          <Route path='quick-pickup-requests' element={<Navigate to='/ptl/pickups/quick' replace />} />

          <Route
            path='ptl/pickups/detailed'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <CreatePickupRequest />
              </ProtectedRoute>
            }
          />
          <Route path='create-pickup-order' element={<Navigate to='/ptl/pickups/detailed' replace />} />

          <Route
            path='ptl/pickups/all/:id'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <PickupRequestDetails />
              </ProtectedRoute>
            }
          />
          <Route path='ptl-pickup-requests/:id' element={<ProtectedRoute role='PTL_ACCESS'><PickupRequestDetails /></ProtectedRoute>} />

          <Route
            path='ptl/pickups/all'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <PtlPickupRequests />
              </ProtectedRoute>
            }
          />
          <Route path='ptl-pickup-requests' element={<Navigate to='/ptl/pickups/all' replace />} />

          {/* ===================== PTL - Shipments ===================== */}
          <Route
            path='ptl/shipments/all'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2BOrderSummary />
              </ProtectedRoute>
            }
          />
          <Route path='ptl-shipments' element={<Navigate to='/ptl/shipments/all' replace />} />

          {/* Non-ABD views: same pages, scoped to appointdeliveryRequired != true */}
          <Route
            path='ptl/shipments/non-abd'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2BOrderSummary key='non-abd' nonAbdOnly />
              </ProtectedRoute>
            }
          />
          <Route
            path='ptl/shipments/non-abd/open'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <OpenShipment key='non-abd' nonAbdOnly />
              </ProtectedRoute>
            }
          />
          <Route
            path='ptl/shipments/non-abd/under-process'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <UnderProcessOrders key='non-abd' nonAbdOnly />
              </ProtectedRoute>
            }
          />
          <Route
            path='ptl/edd-breach-attribution'
            element={<ProtectedRoute role='PTL_ACCESS'><EddBreachAttribution /></ProtectedRoute>}
          />
          <Route path='ptl/pod-analytics' element={<ProtectedRoute role='PTL_ACCESS'><PodAnalytics /></ProtectedRoute>} />
          <Route path='ptl/billing/overview' element={<ProtectedRoute role='PTL_ACCESS'><PtlBillingOverview /></ProtectedRoute>} />
          <Route path='ptl/billing/review' element={<ProtectedRoute role='PTL_ACCESS'><PtlBillingReview /></ProtectedRoute>} />
          <Route path='ptl/billing/files' element={<ProtectedRoute role='PTL_ACCESS'><PtlBillingFiles /></ProtectedRoute>} />
          <Route path='ptl/billing/adhoc' element={<ProtectedRoute role='PTL_ACCESS'><PtlAdhocCharges /></ProtectedRoute>} />
          <Route path='ptl/billing/terms' element={<ProtectedRoute role='PTL_ACCESS'><PtlBillingTerms /></ProtectedRoute>} />
          <Route
            path='ptl/team-master'
            element={<MultiRoleProtectedRoute role={[PTL_EDD_ADMIN_ACCESS]}><PtlTeamMaster /></MultiRoleProtectedRoute>}
          />
          <Route
            path='ptl/serviceability'
            element={<ProtectedRoute role='PTL_ACCESS'><BulkServiceability shipmentType='B2B' /></ProtectedRoute>}
          />
          <Route path='ptl/merchant-setup/onboarding' element={<ProtectedRoute role='PTL_ACCESS'><PtlOnboardingHealth /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/onboarding/:merchantId/:step' element={<ProtectedRoute role='PTL_ACCESS'><PtlOnboardingStep key='onboard' mode='onboard' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/update' element={<ProtectedRoute role='PTL_ACCESS'><PtlMerchantUpdate /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/update/:merchantId' element={<ProtectedRoute role='PTL_ACCESS'><PtlMerchantHub /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/update/:merchantId/:step' element={<ProtectedRoute role='PTL_ACCESS'><PtlOnboardingStep key='update' mode='update' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map' element={<ProtectedRoute role='PTL_ACCESS'><PtlZoneMapStandard /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/overrides' element={<ProtectedRoute role='PTL_ACCESS'><PtlZoneOverrides /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/overrides/:merchantId' element={<ProtectedRoute role='PTL_ACCESS'><PtlZoneOverrideMerchant /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/overrides/:merchantId/upload' element={<ProtectedRoute role='PTL_ACCESS'><PtlUploadScreen key='merchant-zone-map' target='merchant-zone-map' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/overrides/:merchantId/history' element={<ProtectedRoute role='PTL_ACCESS'><PtlHistoryScreen key='merchant-zone-map' target='merchant-zone-map' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/upload' element={<ProtectedRoute role='PTL_ACCESS'><PtlUploadScreen key='zone-map' target='zone-map' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/zone-map/history' element={<ProtectedRoute role='PTL_ACCESS'><PtlHistoryScreen key='zone-map' target='zone-map' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/upload' element={<ProtectedRoute role='PTL_ACCESS'><PtlUploadScreen key='tat' target='tat' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/history' element={<ProtectedRoute role='PTL_ACCESS'><PtlHistoryScreen key='tat' target='tat' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat' element={<ProtectedRoute role='PTL_ACCESS'><PtlTatStandard /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/courier' element={<ProtectedRoute role='PTL_ACCESS'><PtlTatCourier /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/courier/lanes' element={<ProtectedRoute role='PTL_ACCESS'><PtlTatCourierLanes /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/courier/upload' element={<ProtectedRoute role='PTL_ACCESS'><PtlUploadScreen key='courier-tat' target='courier-tat' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/courier/history' element={<ProtectedRoute role='PTL_ACCESS'><PtlHistoryScreen key='courier-tat' target='courier-tat' /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/custom' element={<ProtectedRoute role='PTL_ACCESS'><PtlTatCustom /></ProtectedRoute>} />
          <Route path='ptl/merchant-setup/tat/custom/:merchantId' element={<ProtectedRoute role='PTL_ACCESS'><PtlTatCustomMerchant /></ProtectedRoute>} />
          <Route path='ptl/oda' element={<ProtectedRoute role='PTL_ACCESS'><PtlOdaPincodes /></ProtectedRoute>} />
          <Route path='ptl/oda/bands' element={<ProtectedRoute role='PTL_ACCESS'><PtlOdaBands /></ProtectedRoute>} />
          <Route path='ptl/oda/upload' element={<ProtectedRoute role='PTL_ACCESS'><PtlUploadScreen key='oda-pincodes' target='oda-pincodes' /></ProtectedRoute>} />
          <Route path='ptl/oda/shipments' element={<ProtectedRoute role='PTL_ACCESS'><PtlOdaShipments /></ProtectedRoute>} />
          <Route path='ptl/oda/history' element={<ProtectedRoute role='PTL_ACCESS'><PtlOdaHistory /></ProtectedRoute>} />

          <Route
            path='ptl/shipments/open'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <OpenShipment />
              </ProtectedRoute>
            }
          />
          <Route path='open-shipment' element={<Navigate to='/ptl/shipments/open' replace />} />

          <Route
            path='ptl/shipments/appointments'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <AppointmentDeliveries />
              </ProtectedRoute>
            }
          />
          <Route path='ptl-appointment-deliveries' element={<Navigate to='/ptl/shipments/appointments' replace />} />

          {/* ===================== Appointment Deliveries V2 ===================== */}
          <Route
            path='appointments/all'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsAll /></ProtectedRoute>}
          />
          <Route
            path='appointments/missed-repeat'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsMissedRepeat /></ProtectedRoute>}
          />
          <Route
            path='appointments/needs-action'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsNeedsAction /></ProtectedRoute>}
          />
          <Route
            path='appointments/abd-tagging'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsAbdTagging /></ProtectedRoute>}
          />
          <Route
            path='appointments/analytics'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsAnalytics /></ProtectedRoute>}
          />
          <Route
            path='appointments/bulk-upload'
            element={<ProtectedRoute role='PTL_ACCESS'><AppointmentsBulkUpload /></ProtectedRoute>}
          />
          <Route
            path='appointments/miss-reasons'
            element={<ProtectedRoute role='INTERNAL'><AppointmentsMissReasons /></ProtectedRoute>}
          />
          <Route
            path='appointments/edited'
            element={<ProtectedRoute role='INTERNAL'><AppointmentsEdited /></ProtectedRoute>}
          />
          <Route
            path='appointments/overdue'
            element={<ProtectedRoute role='INTERNAL'><AppointmentsOverdue /></ProtectedRoute>}
          />
          <Route
            path='tools/reason-master'
            element={<ProtectedRoute role='INTERNAL'><ReasonMasterSettings /></ProtectedRoute>}
          />
          <Route
            path='tools/address-quality'
            element={<ProtectedRoute role='INTERNAL'><NetraIntelligenceDashboard /></ProtectedRoute>}
          />
          <Route path='appointments' element={<Navigate to='/appointments/all' replace />} />

          <Route
            path='ptl/shipments/under-process'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <UnderProcessOrders />
              </ProtectedRoute>
            }
          />
          <Route path='ptl-under-process' element={<Navigate to='/ptl/shipments/under-process' replace />} />

          {/* ===================== PTL - Uploads ===================== */}
          <Route
            path='ptl/uploads/tracking'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2Bupload />
              </ProtectedRoute>
            }
          />
          <Route path='B2Buploads' element={<Navigate to='/ptl/uploads/tracking' replace />} />

          <Route
            path='ptl/uploads/tracking-v2'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2bUploadV2 />
              </ProtectedRoute>
            }
          />
          <Route path='b2b_tracking_upload' element={<Navigate to='/ptl/uploads/tracking-v2' replace />} />

          <Route
            path='ptl/uploads/manifestation'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2bCreateUpload />
              </ProtectedRoute>
            }
          />
          <Route path='b2b_create_upload' element={<Navigate to='/ptl/uploads/manifestation' replace />} />

          <Route
            path='ptl/uploads/additional-charges'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <B2BUploadAdditionalCharges />
              </ProtectedRoute>
            }
          />
          <Route path='b2b_charges_upload' element={<Navigate to='/ptl/uploads/additional-charges' replace />} />

          {/* ===================== PTL - Downloads ===================== */}
          <Route
            path='ptl/downloads/labels'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <BulkDownloadLabelsB2B />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-download-labels-b2b' element={<Navigate to='/ptl/downloads/labels' replace />} />

          {/* ===================== Weight - Merchant ===================== */}
          <Route
            path='weight/merchant/freeze-upload'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightFreezeUpload />
              </ProtectedRoute>
            }
          />
          <Route path='weightfreeze-upload' element={<Navigate to='/weight/merchant/freeze-upload' replace />} />

          <Route
            path='weight/merchant/freeze-details'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightFreezeDetails />
              </ProtectedRoute>
            }
          />
          <Route path='weightfreeze-details' element={<Navigate to='/weight/merchant/freeze-details' replace />} />

          <Route
            path='weight/merchant/all-discrepancy'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <AllDiscrepancy />
              </ProtectedRoute>
            }
          />
          <Route path='all-discrepancy' element={<Navigate to='/weight/merchant/all-discrepancy' replace />} />

          <Route
            path='weight/merchant/image-link'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <UploadImages />
              </ProtectedRoute>
            }
          />
          <Route path='image-link' element={<Navigate to='/weight/merchant/image-link' replace />} />

          {/* ===================== Weight - Courier ===================== */}
          <Route
            path='weight/courier/mis-upload'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <CourierMISUpload />
              </ProtectedRoute>
            }
          />
          <Route path='courier-mis-upload' element={<Navigate to='/weight/courier/mis-upload' replace />} />

          <Route
            path='weight/courier/bulk-action'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightDiscrepancyBulkAction />
              </ProtectedRoute>
            }
          />
          <Route path='weight-discrepancy-bulk-action' element={<Navigate to='/weight/courier/bulk-action' replace />} />

          <Route
            path='weight/courier/bulk-image-upload'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <BulkImageUpload />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-image-upload' element={<Navigate to='/weight/courier/bulk-image-upload' replace />} />

          <Route
            path='weight/courier/dws-config'
            element={
              <ProtectedRoute role='AP_RESTRICTED'>
                <DwsConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path='weight/courier/dws-weight-upload'
            element={
              <ProtectedRoute role='AP_RESTRICTED'>
                <DwsWeightUpload />
              </ProtectedRoute>
            }
          />

          {/* ===================== Weight Ledger ===================== */}
          <Route
            path='weight/ledger'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightLedger />
              </ProtectedRoute>
            }
          />
          <Route path='weight-ledger' element={<Navigate to='/weight/ledger' replace />} />
          <Route
            path='weight/ledger/calc/:awbNumber'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <PredictedWeightPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='weight/ledger/calc/:awbNumber/exact-matches'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <ExactMatchShipmentsPage />
              </ProtectedRoute>
            }
          />

          {/* ===================== Weight v2 (fresh admin module) ===================== */}
          <Route
            path='weight/v2/disputes'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightV2Disputes />
              </ProtectedRoute>
            }
          />
          <Route
            path='weight/v2/freeze-requests'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightV2FreezeRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path='weight/v2/settings'
            element={
              <ProtectedRoute role='WEIGHT_DESC'>
                <WeightV2Settings />
              </ProtectedRoute>
            }
          />

          <Route
            path='d2c/operations/manual-status-update'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <ManualStatusUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path='ptl/operations/manual-status-update'
            element={
              <ProtectedRoute role='PTL_ACCESS'>
                <ManualStatusUpdate />
              </ProtectedRoute>
            }
          />
          <Route path='tools/manual-status-update' element={<Navigate to='/d2c/operations/manual-status-update' replace />} />
          <Route path='dws-config' element={<Navigate to='/weight/courier/dws-config' replace />} />

          {/* ===================== PACE ===================== */}
          <Route
            path='pace/allocation'
            element={
              <ProtectedRoute role='INTERNAL'>
                <WeightZoneRulesBuilder />
              </ProtectedRoute>
            }
          />
          <Route path='uploads/build-rules' element={<Navigate to='/pace/allocation' replace />} />
          <Route
            path='pace/about'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceAboutPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/allocations'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ShadowRunPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/analytics'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceAnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/business-knobs'
            element={
              <ProtectedRoute role='INTERNAL'>
                <BusinessKnobsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/service-types'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ServiceTypesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/merchant-list'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceV2MerchantList />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/external-shadow-run'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ExternalShadowRunPage />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/daily-share'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/onboarded-merchants'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceMerchantList />
              </ProtectedRoute>
            }
          />
          <Route
            path='pace/shipment-counts'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PaceShipmentCounts />
              </ProtectedRoute>
            }
          />
          <Route
            path='prism/iedd'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelligentEDD />
              </ProtectedRoute>
            }
          />

          {/* There is one PACE: the pages that lived under /pace/v2/ moved to /pace/ in Nov 2026. Old links redirect. */}
          <Route path='pace/v2/about' element={<Navigate to='/pace/about' replace />} />
          <Route path='pace/v2/shadow-run' element={<Navigate to='/pace/allocations' replace />} />
          <Route path='pace/v2/analytics' element={<Navigate to='/pace/analytics' replace />} />
          <Route path='pace/v2/business-knobs' element={<Navigate to='/pace/business-knobs' replace />} />
          <Route path='pace/v2/service-types' element={<Navigate to='/pace/service-types' replace />} />
          <Route path='pace/v2/merchant-list' element={<Navigate to='/pace/merchant-list' replace />} />
          <Route path='pace/v2/external-shadow-run' element={<Navigate to='/pace/external-shadow-run' replace />} />
          <Route path='tools/pace-analytics' element={<Navigate to='/pace/daily-share' replace />} />
          <Route path='pace/simulation' element={<Navigate to='/pace/external-shadow-run' replace />} />
          <Route path='pace/simulation/:id' element={<Navigate to='/pace/external-shadow-run' replace />} />
          <Route path='tools/pace-simulation' element={<Navigate to='/pace/external-shadow-run' replace />} />
          <Route path='tools/pace-simulation/:id' element={<Navigate to='/pace/external-shadow-run' replace />} />
          <Route path='pace/awb-simulation' element={<Navigate to='/pace/external-shadow-run' replace />} />

          <Route
            path='tools/bulk-serviceability'
            element={
              <ProtectedRoute role='INTERNAL'>
                <BulkServiceability />
              </ProtectedRoute>
            }
          />

          {/* ===================== Tools ===================== */}
          <Route
            path='tools/serviceability'
            element={
              <ProtectedRoute role='TOOLS'>
                <Serviceability />
              </ProtectedRoute>
            }
          />
          <Route path='serviceability' element={<Navigate to='/tools/serviceability' replace />} />

          {/* ===================== Serviceability Intelligence ===================== */}
          <Route
            path='serviceability-intel'
            element={<Navigate to='/serviceability-intel/trends/overview' replace />}
          />
          <Route
            path='serviceability-intel/trends/overview'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelTrendsOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/coverage/delivery'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelCoverageDelivery />
              </ProtectedRoute>
            }
          />
          {/* per-delivery-mode serviceability (mode-scoped Delivery Coverage) */}
          <Route
            path='serviceability-intel/serviceability/:mode'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelCoverageDelivery />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/coverage/pickup'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelCoveragePickup />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/block/new'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelBlockNew />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/block/active'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelBlockActive />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/servicetype/performance'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelServiceTypePerformance />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/block/rto'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelBlockRto />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/stuck-orders'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelStuckOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/dashboard'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/coverage/non-serviceable'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelNonServiceable />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/coverage/analysis'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelCoverageAnalysis />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/stuck-orders/trends'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelStuckTrends />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/coverage/uploads'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelCoverageUploads />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/weights'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelWeightSlabs />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/setup/groups'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelSetupGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/servicetype/taxonomy'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelServiceTypeTaxonomy />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/servicetype/guide'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelServiceTypeGuide />
              </ProtectedRoute>
            }
          />
          <Route
            path='serviceability-intel/bulk-serviceability'
            element={
              <ProtectedRoute role='INTERNAL'>
                <IntelBulkServiceability />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/rate-calculator'
            element={
              <ProtectedRoute role='INTERNAL'>
                <CalculateRate />
              </ProtectedRoute>
            }
          />
          <Route path='shipment-rate-calculator' element={<Navigate to='/tools/rate-calculator' replace />} />

          <Route
            path='tools/edd-details'
            element={
              <ProtectedRoute role='TOOLS'>
                <AwbEddDetails />
              </ProtectedRoute>
            }
          />
          <Route path='edd-details' element={<Navigate to='/tools/edd-details' replace />} />

          <Route
            path='tools/carrier-logs'
            element={
              <ProtectedRoute role='TOOLS'>
                <ClickPostLogs />
              </ProtectedRoute>
            }
          />
          <Route path='carrier-logs' element={<Navigate to='/tools/carrier-logs' replace />} />

          <Route
            path='tools/awb-mis'
            element={
              <ProtectedRoute role='TOOLS'>
                <DonwloadMISfromAWB />
              </ProtectedRoute>
            }
          />
          <Route path='awb-based-mis' element={<Navigate to='/tools/awb-mis' replace />} />

          <Route
            path='tools/awb-pod'
            element={
              <ProtectedRoute role='TOOLS'>
                <BulkDownloadPOD />
              </ProtectedRoute>
            }
          />
          <Route path='awb-based-pod' element={<Navigate to='/tools/awb-pod' replace />} />

          <Route
            path='tools/sorter-image'
            element={
              <ProtectedRoute role='TOOLS'>
                <SorterImage />
              </ProtectedRoute>
            }
          />
          <Route path='sorter-image' element={<Navigate to='/tools/sorter-image' replace />} />

          <Route
            path='tools/qc-mapping'
            element={
              <ProtectedRoute role='TOOLS'>
                <QcClickPost />
              </ProtectedRoute>
            }
          />
          <Route path='qc-mapping' element={<Navigate to='/tools/qc-mapping' replace />} />

          <Route
            path='courier-performance/qc-monitor'
            element={
              <MultiRoleProtectedRoute role={['ROLE_PROSHIPADMIN']}>
                <QcMonitor />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='tools/qc-monitor' element={<Navigate to='/courier-performance/qc-monitor' replace />} />

          {/* ── ProShip Direct ──────────────────────────────────────────────
              ROLE_PROSHIPADMIN only, mirroring the backend's @PreAuthorize on
              /api/direct/admin/**. The detail route is nested under the list so
              a deep link lands on the same guard. */}
          <Route
            path='direct/subscriptions'
            element={
              <MultiRoleProtectedRoute role={DIRECT_ROLE_GATING}>
                <DirectSubscriptions />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='direct/subscriptions/:id'
            element={
              <MultiRoleProtectedRoute role={DIRECT_ROLE_GATING}>
                <DirectSubscriptionDetail />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='direct/offers'
            element={
              <MultiRoleProtectedRoute role={DIRECT_ROLE_GATING}>
                <DirectOffers />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='direct/plans'
            element={
              <MultiRoleProtectedRoute role={DIRECT_ROLE_GATING}>
                <DirectPlanCatalog />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='direct/default-accounts'
            element={
              <MultiRoleProtectedRoute role={DIRECT_ROLE_GATING}>
                <DirectDefaultAccounts />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='direct' element={<Navigate to='/direct/subscriptions' replace />} />

          <Route
            path='tools/label-config'
            element={
              <ProtectedRoute role='TOOLS'>
                <LabelTabs />
              </ProtectedRoute>
            }
          />
          <Route path='label-config' element={<Navigate to='/tools/label-config' replace />} />

          <Route
            path='tools/vas-invoicing'
            element={
              <ProtectedRoute role='TOOLS'>
                <SMSWAInvoicing />
              </ProtectedRoute>
            }
          />
          <Route path='vas-invoicing' element={<Navigate to='/tools/vas-invoicing' replace />} />

          {/* V1 (Freshdesk tickets) until go-live; after it, V1's routes open EMS V2 (see emsV2Visibility.js). */}
          <Route
            path='tools/escalation'
            element={EMS_V2_ENABLED ? <Navigate to='/tools/escalation-v2' replace /> : (
              <ProtectedRoute role='TOOLS'>
                <EscalationManagement />
              </ProtectedRoute>
            )}
          />
          <Route path='support' element={<Navigate to={ESCALATION_HOME} replace />} />

          <Route
            path='tools/escalation-v2'
            element={
              <ProtectedRoute role='TOOLS'>
                <EscalationManagementV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation-v2/view'
            element={
              <ProtectedRoute role='TOOLS'>
                <EscalationViewTicketV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation-v2/analytics'
            element={
              <ProtectedRoute role='TOOLS'>
                <EscalationAnalyticsV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation-v2/reports'
            element={
              <ProtectedRoute role='ESCALATION_ADMIN'>
                <EscalationReportSchedulesV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation-v2/settings'
            element={
              <ProtectedRoute role='ESCALATION_ADMIN'>
                <EscalationEmailSettingsV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation-v2/categories'
            element={
              <ProtectedRoute role='ESCALATION_ADMIN'>
                <EscalationCategoriesV2 />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/escalation/view'
            element={EMS_V2_ENABLED ? <Navigate to='/tools/escalation-v2' replace /> : (
              <ProtectedRoute role='TOOLS'>
                <ViewEms />
              </ProtectedRoute>
            )}
          />
          <Route path='escalation_management/view' element={<Navigate to={EMS_V2_ENABLED ? '/tools/escalation-v2' : '/tools/escalation/view'} replace />} />

          <Route
            path='tools/refresh-url'
            element={
              <MultiRoleProtectedRoute role={['SA', 'TOOLS']}>
                <RefreshUrl />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='refresh-url' element={<Navigate to='/tools/refresh-url' replace />} />

          <Route
            path='tools/reset-terminal-status'
            element={
              <ProtectedRoute role='ORDER_TERMINAL_RESET'>
                <ResetTerminalStatus />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/rate-card-history'
            element={
              <ProtectedRoute role='TOOLS'>
                <RateCardHistory />
              </ProtectedRoute>
            }
          />

          <Route
            path='tools/order-creation-latency'
            element={
              <ProtectedRoute role='TOOLS'>
                <OrderCreationLatency />
              </ProtectedRoute>
            }
          />

          {/* Data Archival — ROLE_PROSHIPADMIN only, mirroring the backend's admin check on /api/tools/archive/collections. */}
          <Route
            path='tools/data-archival'
            element={
              <MultiRoleProtectedRoute role={['ROLE_PROSHIPADMIN']}>
                <DataArchival />
              </MultiRoleProtectedRoute>
            }
          />


          {/* ===================== Courier Config ===================== */}
          <Route
            path='courier-config/master'
            element={
              <ProtectedRoute role='INTERNAL'>
                <AllCourierTabs />
              </ProtectedRoute>
            }
          />
          <Route path='couriers' element={<Navigate to='/courier-config/master' replace />} />

          <Route
            path='courier-config/master/:id'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ViewC />
              </ProtectedRoute>
            }
          />
          <Route path='couriers/:id' element={<ProtectedRoute role='INTERNAL'><ViewC /></ProtectedRoute>} />

          <Route
            path='courier-config/setup/:id'
            element={
              <ProtectedRoute role='INTERNAL'>
                <Setup />
              </ProtectedRoute>
            }
          />
          <Route path='courier/setup/:id' element={<ProtectedRoute role='INTERNAL'><Setup /></ProtectedRoute>} />

          <Route
            path='courier-config/zone-mapping'
            element={
              <ProtectedRoute role='TOOLS'>
                <Zone />
              </ProtectedRoute>
            }
          />
          <Route path='zone' element={<Navigate to='/courier-config/zone-mapping' replace />} />

          <Route
            path='courier-config/zone-override'
            element={
              <MultiRoleProtectedRoute role={['SA', 'TOOLS']}>
                <ZoneOverRide />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='zone-override' element={<Navigate to='/courier-config/zone-override' replace />} />

          <Route
            path='courier-config/cod-recon'
            element={
              <ProtectedRoute role='INTERNAL'>
                <CourierCodReconTabs />
              </ProtectedRoute>
            }
          />
          <Route path='courier-cod-reconciliation' element={<Navigate to='/courier-config/cod-recon' replace />} />

          <Route
            path='courier-config/cod-upload'
            element={
              <ProtectedRoute role='INTERNAL'>
                <CodUpload />
              </ProtectedRoute>
            }
          />
          <Route path='cod-upload' element={<Navigate to='/courier-config/cod-upload' replace />} />

          <Route
            path='courier-config/invoice-recon'
            element={
              <ProtectedRoute role='INTERNAL'>
                <InvoiceUpload />
              </ProtectedRoute>
            }
          />
          <Route path='courier-invoice-recon' element={<Navigate to='/courier-config/invoice-recon' replace />} />

          <Route
            path='courier-config/status-map'
            element={
              <ProtectedRoute role='SA'>
                <CourierStatusMap />
              </ProtectedRoute>
            }
          />
          <Route path='courier-status-map' element={<Navigate to='/courier-config/status-map' replace />} />

          <Route
            path='courier-config/pricing-errors'
            element={
              <ProtectedRoute role='TOOLS'>
                <CourierPriceMissing />
              </ProtectedRoute>
            }
          />
          <Route path='courier-pricing-missing' element={<Navigate to='/courier-config/pricing-errors' replace />} />

          <Route
            path='courier-config/direct'
            element={
              <ProtectedRoute role='SA'>
                <CourierConfiguration />
              </ProtectedRoute>
            }
          />
          <Route path='courier-config' element={<Navigate to='/courier-config/direct' replace />} />

          <Route
            path='courier-config/bulk-pincode-block'
            element={
              <ProtectedRoute role='TOOLS'>
                <BulkBlockedPincodes />
              </ProtectedRoute>
            }
          />

          {/* ===================== Merchant Config ===================== */}
          <Route
            path='merchant-config/merchants'
            element={
              <ProtectedRoute role='INTERNAL'>
                <AllMerchants />
              </ProtectedRoute>
            }
          />
          <Route
            path='merchant-config/pickup-drop-mapping'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ShopifyEddLocation />
              </ProtectedRoute>
            }
          />
          <Route path='merchants' element={<Navigate to='/merchant-config/merchants' replace />} />

          <Route
            path='merchant-config/kyc-analytics'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_KYC_APPROVAL', 'INTERNAL']}>
                <KYCAnalytics />
              </MultiRoleProtectedRoute>
            }
          />
          {/* KYC status drill-down pages */}
          <Route
            path='merchant-config/kyc/:view'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_KYC_APPROVAL', 'INTERNAL']}>
                <KycMerchantList />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== Merchant Onboarding Flow (Step 1 of 4) ===================== */}
          <Route
            path='merchant-config/onboarding/setup-kyc'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <Step1_SetupKYC />
              </MultiRoleProtectedRoute>
            }
          />

          <Route
            path='merchant-config/courier-allocation'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'MERCHANT_COURIER_ALLOCATION']}>
                <CourierAllocationPicker />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/merchant/:id'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'MERCHANT_COURIER_ALLOCATION']}>
                <MerchantDetailTabs />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='merchant/:id' element={<MultiRoleProtectedRoute role={['INTERNAL', 'MERCHANT_COURIER_ALLOCATION']}><MerchantDetailTabs /></MultiRoleProtectedRoute>} />

          {/* Was <ViewM /> (pages/merchants/View.js) -- a component whose body is a
              console.log followed by `return null`, i.e. a blank white page for any
              FINANCE user who opened a merchant from a finance context. Now renders
              the real merchant surface. The FINANCE guard is deliberately unchanged:
              this fixes what the route *does*, not who may reach it. */}
          <Route
            path='merchant-config/merchants/:id'
            element={
              <ProtectedRoute role='FINANCE'>
                <MerchantDetailTabs />
              </ProtectedRoute>
            }
          />
          <Route path='merchants/:id' element={<ProtectedRoute role='FINANCE'><MerchantDetailTabs /></ProtectedRoute>} />

          <Route
            path='merchant-config/cod-config'
            element={
              <ProtectedRoute role='FINANCE'>
                <CODConfigurationTabs />
              </ProtectedRoute>
            }
          />
          <Route path='cod-merchantConfig' element={<Navigate to='/merchant-config/cod-config' replace />} />

          <Route
            path='merchant-config/pricing-errors'
            element={
              <ProtectedRoute role='TOOLS'>
                <MerchantPriceMissing />
              </ProtectedRoute>
            }
          />
          <Route path='merchant-pricing-missing' element={<Navigate to='/merchant-config/pricing-errors' replace />} />

          <Route
            path='merchant-config/default-pricing'
            element={
              <ProtectedRoute role='INTERNAL'>
                <DefaultPricing />
              </ProtectedRoute>
            }
          />
          <Route path='default-pricing' element={<Navigate to='/merchant-config/default-pricing' replace />} />

          {/* Merchant Setup › Zone Mapping (merchant base zone map + per-merchant overrides). Lookup is
              read-only: TOOLS (+INTERNAL). Override / base upload write the map every merchant prices on, so
              they need the MERCHANT_ZONE_ADMIN module (granted per user by a Proship admin); the backend
              enforces ROLE_PROSHIPADMIN + that module on the two write APIs (MerchantZoneAccess). */}
          {/* Rendered inside SupplySideLayout: the pages share the supply-side visual language and its
              scoped stylesheet (Badge / FileDrop / Modal / SupplyTable need the .supply-scope wrapper). */}
          <Route
            path='merchant-config/zones/lookup'
            element={
              <MultiRoleProtectedRoute role={['TOOLS', 'INTERNAL']}>
                <SupplySideLayout>
                  <ZoneLookup />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/zones/override'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ZONE_ADMIN']}>
                <SupplySideLayout>
                  <MerchantZoneOverride />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/zones/base-upload'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ZONE_ADMIN']}>
                <SupplySideLayout>
                  <MerchantZoneBaseUpload />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          {/* Lookup is open to the most roles (TOOLS + INTERNAL), so the group's default never bounces anyone */}
          <Route path='merchant-config/zones' element={<Navigate to='/merchant-config/zones/lookup' replace />} />

          {/* ===================== Onboarding Setup (Steps 1-3) ===================== */}
          <Route
            path='merchant-config/pricing-setup/list'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantListing />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/pricing-setup/all'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantsAllListing />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/pricing-setup'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantPricingWizard />
              </MultiRoleProtectedRoute>
            }
          />

          <Route
            path='merchant-config/tat-setup'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantTatWizard />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/tat-setup/:merchantOid'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantTatWizard />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== Allocation Setup (Step 4) ===================== */}
          <Route
            path='merchant-config/d2c-allocation'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ALLOCATION', 'INTERNAL']}>
                <D2CAllocation />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/d2c-allocation/:merchantId'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ALLOCATION', 'INTERNAL']}>
                <D2CAllocation />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== D2C Freight Pricing Agent ===================== */}
          {/* Guards honour D2C_ROLE_GATING (constants.js): real per-role access when
              true, open to any logged-in user when false (TEMP testing bypass).
              PROPOSAL_CREATE = SL · PROPOSAL_L1 = L1 · PROPOSAL_ADMIN = FH. */}
          {/* Index → redirect to the user's workspace by JWT accessList (tab routing) */}
          <Route path='d2c-pricing' element={<D2CMultiGuard><D2CPLanding /></D2CMultiGuard>} />
          {/* Sales Leader */}
          <Route path='d2c-pricing/sl/dashboard' element={<D2CGuard role='PROPOSAL_CREATE'><D2CPSLDashboard /></D2CGuard>} />
          <Route path='d2c-pricing/sl/approval-queue' element={<D2CGuard role='PROPOSAL_CREATE'><D2CPSLApprovalQueue /></D2CGuard>} />
          <Route path='d2c-pricing/sl/history' element={<D2CGuard role='PROPOSAL_CREATE'><D2CPSLHistory /></D2CGuard>} />
          <Route path='d2c-pricing/sl/counter-review' element={<D2CGuard role='PROPOSAL_CREATE'><D2CPSLCounterReview /></D2CGuard>} />
          {/* L1 Pricing Reviewer */}
          <Route path='d2c-pricing/l1/dashboard' element={<D2CGuard role='PROPOSAL_L1'><D2CPL1Dashboard /></D2CGuard>} />
          <Route path='d2c-pricing/l1/approval-queue' element={<D2CGuard role='PROPOSAL_L1'><D2CPL1ApprovalQueue /></D2CGuard>} />
          <Route path='d2c-pricing/l1/review' element={<D2CGuard role='PROPOSAL_L1'><D2CPL1DealReview /></D2CGuard>} />
          <Route path='d2c-pricing/l1/history' element={<D2CGuard role='PROPOSAL_L1'><D2CPL1History /></D2CGuard>} />
          {/* Functional Head */}
          <Route path='d2c-pricing/fh/dashboard' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHDashboard /></D2CGuard>} />
          <Route path='d2c-pricing/fh/approval-queue' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHApprovalQueue /></D2CGuard>} />
          <Route path='d2c-pricing/fh/review' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHDealReview /></D2CGuard>} />
          <Route path='d2c-pricing/fh/rules' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHRules /></D2CGuard>} />
          <Route path='d2c-pricing/fh/masters' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHMasters /></D2CGuard>} />
          <Route path='d2c-pricing/fh/history' element={<D2CGuard role='PROPOSAL_ADMIN'><D2CPFHHistory /></D2CGuard>} />
          {/* Creating proposals is Sales-Leader-only (PROPOSAL_CREATE) — matches the backend gate. */}
          <Route path='d2c-pricing/new-proposal' element={<D2CGuard role='PROPOSAL_CREATE'><D2CPNewProposal /></D2CGuard>} />
          {/* Shared — any of the three */}
          <Route path='d2c-pricing/resources/gtm-toolkit' element={<D2CMultiGuard><D2CPGTMToolkit /></D2CMultiGuard>} />
          <Route path='d2c-pricing/resources/guide' element={<D2CMultiGuard><D2CPGuide /></D2CMultiGuard>} />

          {/* ===================== GrowthOS migration ===================== */}
          {/* Guard honours GROWTHOS_ROLE_GATING (constants.js): open to any logged-in user
              until the backend actually issues GROWTHOS_ADMIN in a real JWT. One route per
              slice as they land — Brands today, more follow the same shape. */}
          <Route path='growthos/brands' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><GrowthOsBrandsPage /></GrowthOsGuard>} />
          <Route path='growthos/budget' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><GrowthOsBudgetPage /></GrowthOsGuard>} />
          <Route path='growthos/pocs' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><GrowthOsPocsPage /></GrowthOsGuard>} />
          <Route path='growthos/pocs-analytics' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><SalesPocDashboardPage /></GrowthOsGuard>} />
          <Route path='growthos/pocs-analytics/:personId' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><SalesPocIndividualPage /></GrowthOsGuard>} />
          <Route path='growthos/connectors' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><GrowthOsConnectorsPage /></GrowthOsGuard>} />
          <Route path='growthos/retention' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><GrowthOsRetentionPage /></GrowthOsGuard>} />
          <Route path='growthos/sme' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><SmePerformancePage /></GrowthOsGuard>} />
          <Route path='growthos/executive' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><ExecutivePage /></GrowthOsGuard>} />
          <Route path='growthos/decision-insights' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><DecisionInsightsPage /></GrowthOsGuard>} />
          <Route path='growthos/marketing-funnel' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><MarketingFunnelPage /></GrowthOsGuard>} />
          <Route path='growthos/pipeline-funnel' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><PipelineFunnelPage /></GrowthOsGuard>} />
          <Route path='growthos/email-marketing' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><EmailMarketingPage /></GrowthOsGuard>} />
          <Route path='growthos/linkedin-abm' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><LinkedinAbmPage /></GrowthOsGuard>} />
          <Route path='growthos/hubspot-review' element={<GrowthOsGuard role='GROWTHOS_ADMIN'><HubspotReviewPage /></GrowthOsGuard>} />

          {/* ===== D2C Pricing Agent — Mockups (NEW demo pages A/C/D; existing routes untouched) ===== */}

          {/* ===================== PII Data Requests (bulk PII with 2-level approval) ===================== */}
          {/* Any of the three PII grants opens the page; tabs inside narrow by grant.
              Server enforces all of it again — this guard is presentational. */}
          <Route
            path='pii-requests'
            element={
              <MultiRoleProtectedRoute role={['PII_REQUEST', 'PII_APPROVER_L1', 'PII_APPROVER_L2']}>
                <PiiRequests />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== Update Existing Merchant (post-onboarding edits) ===================== */}
          <Route
            path='merchant-config/pricing-update'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantPricingWizard mode='update' />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/tat-update/:merchantOid'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ONBOARDING', 'INTERNAL']}>
                <MerchantTatWizard mode='update' />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='merchant-config/update/allocation'
            element={
              <MultiRoleProtectedRoute role={['MERCHANT_ALLOCATION', 'INTERNAL']}>
                <D2CAllocation mode='update' />
              </MultiRoleProtectedRoute>
            }
          />

          <Route
            path='merchant-config/product-master'
            element={
              <ProtectedRoute role='INTERNAL'>
                <ProductMaster />
              </ProtectedRoute>
            }
          />
          <Route path='product-master' element={<Navigate to='/merchant-config/product-master' replace />} />

          <Route
            path='merchant-config/pickup-locations'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantLocations />
              </ProtectedRoute>
            }
          />
          <Route exact path='/pickup-locations' element={<Navigate to='/merchant-config/pickup-locations' replace />} />

          <Route
            path='merchant-config/delivery-locations'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantDeliveryLocations />
              </ProtectedRoute>
            }
          />
          <Route exact path='/delivery-locations' element={<Navigate to='/merchant-config/delivery-locations' replace />} />

          <Route
            path='merchant-config/ndr-automated-rule'
            element={
              <ProtectedRoute role='INTERNAL'>
                <AutomatedRuleUpload kind='NDR' />
              </ProtectedRoute>
            }
          />
          <Route path='ndr-automated-rule' element={<Navigate to='/merchant-config/ndr-automated-rule' replace />} />

          <Route
            path='merchant-config/npr-automated-rule'
            element={
              <ProtectedRoute role='INTERNAL'>
                <AutomatedRuleUpload kind='NPR' />
              </ProtectedRoute>
            }
          />
          <Route path='npr-automated-rule' element={<Navigate to='/merchant-config/npr-automated-rule' replace />} />

          {/* ===================== Finance ===================== */}
          <Route
            path='finance/wallet'
            element={
              <ProtectedRoute role='FINANCE'>
                <Wallet />
              </ProtectedRoute>
            }
          />
          <Route path='wallet' element={<Navigate to='/finance/wallet' replace />} />

          <Route
            path='finance/sms-wa-report'
            element={
              <ProtectedRoute role='FINANCE'>
                <MonthlySmsWaReport />
              </ProtectedRoute>
            }
          />

          <Route
            path='finance/razorpay-monthly-dump'
            element={
              <ProtectedRoute role='FINANCE'>
                <RazorpayMonthlyDump />
              </ProtectedRoute>
            }
          />

          <Route
            path='finance/offline-payment'
            element={
              <ProtectedRoute role='FINANCE'>
                <UpdateOffine />
              </ProtectedRoute>
            }
          />
          <Route path='offline-payment' element={<Navigate to='/finance/offline-payment' replace />} />

          <Route
            path='finance/credit-limit'
            element={
              <ProtectedRoute role='FINANCE'>
                <MerchantCreditLimits />
              </ProtectedRoute>
            }
          />
          <Route path='credit-limit' element={<Navigate to='/finance/credit-limit' replace />} />

          {/* Finance Credit Note route — disabled, replaced by AWB-level Credit Note */}
          {/* <Route
            path='finance/credit-note'
            element={
              <ProtectedRoute role='FINANCE'>
                <CreditNoteFinanceList />
              </ProtectedRoute>
            }
          />
          <Route path='credit-note-finance' element={<Navigate to='/finance/credit-note' replace />} /> */}

          <Route
            path='finance/awb-credit-note'
            element={
              <ProtectedRoute role='FINANCE'>
                <MerchantCNUpload />
              </ProtectedRoute>
            }
          />
          <Route path='awb-credit-note' element={<Navigate to='/finance/awb-credit-note' replace />} />

          <Route
            path='finance/lost-damage'
            element={
              <ProtectedRoute role='FINANCE'>
                <FinanceLostDamage />
              </ProtectedRoute>
            }
          />
          <Route path='lost-damage-finance' element={<Navigate to='/finance/lost-damage' replace />} />

          <Route
            path='finance/merchant-invoice'
            element={
              <ProtectedRoute role='FINANCE'>
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route path='finance-merchant-invoice' element={<Navigate to='/finance/merchant-invoice' replace />} />

          <Route
            path='finance/invoice-corrections'
            element={
              <ProtectedRoute role='FINANCE'>
                <MerchantInvoiceCorrections />
              </ProtectedRoute>
            }
          />

          <Route
            path='finance/courier-invoice'
            element={
              <ProtectedRoute role='FINANCE'>
                <CourierInvoice />
              </ProtectedRoute>
            }
          />
          <Route path='courier-invoice' element={<Navigate to='/finance/courier-invoice' replace />} />

          <Route
            path='finance/merchant-wallet'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantWallet />
              </ProtectedRoute>
            }
          />
          <Route path='merchant-wallet' element={<Navigate to='/finance/merchant-wallet' replace />} />

          <Route
            path='finance/cod-reconciliation'
            element={
              <ProtectedRoute role='FINANCE'>
                <CODReconcilation />
              </ProtectedRoute>
            }
          />
          <Route path='reconciliation' element={<Navigate to='/finance/cod-reconciliation' replace />} />

          <Route
            path='finance/cod-remittance'
            element={
              <ProtectedRoute role='FINANCE'>
                {/* <CODRemittance /> */}
                <CODRemittanceTabs />
              </ProtectedRoute>
            }
          />
          <Route path='cod-remittance' element={<Navigate to='/finance/cod-remittance' replace />} />

          <Route
            path='finance/auto-remittance/pending'
            element={
              <ProtectedRoute role='FINANCE'>
                <PendingCODRemittance />
              </ProtectedRoute>
            }
          />
          <Route path='automated-cod-remittance/pending-cod-remittance' element={<Navigate to='/finance/auto-remittance/pending' replace />} />

          <Route
            path='finance/auto-remittance/close'
            element={
              <ProtectedRoute role='FINANCE'>
                <CloseCODRemittance />
              </ProtectedRoute>
            }
          />
          <Route path='automated-cod-remittance/close-cod-remittance' element={<Navigate to='/finance/auto-remittance/close' replace />} />

          <Route
            path='finance/auto-remittance/beneficiary'
            element={
              <ProtectedRoute role='FINANCE'>
                <BeneficiaryDetails />
              </ProtectedRoute>
            }
          />
          <Route path='automated-cod-remittance/beneficiary-master' element={<Navigate to='/finance/auto-remittance/beneficiary' replace />} />

          {/* FINANCE only opens the route; the page itself asks the server
              whether this user is a named approver and shows nothing if not. */}
          <Route
            path='finance/auto-remittance/beneficiary-approval'
            element={
              <ProtectedRoute role='FINANCE'>
                <BeneficiaryApproval />
              </ProtectedRoute>
            }
          />

          <Route
            path='finance/payment-details'
            element={
              <ProtectedRoute role='FINANCE'>
                <PaymentDetails />
              </ProtectedRoute>
            }
          />
          <Route path='payment-details' element={<Navigate to='/finance/payment-details' replace />} />

          <Route
            path='finance/reports'
            element={
              <ProtectedRoute role='REPORTS'>
                <AllReports />
              </ProtectedRoute>
            }
          />
          <Route path='reports' element={<Navigate to='/finance/reports' replace />} />

          {/* Freight Profitability — backend requires ROLE_PROSHIPADMIN + the FREIGHT_PROFITABILITY module (granted per user), so gate on the module. */}
          <Route
            path='finance/freight-profitability'
            element={
              <MultiRoleProtectedRoute role={['FREIGHT_PROFITABILITY']}>
                <FreightProfitability />
              </MultiRoleProtectedRoute>
            }
          />

          {/* Stuck Shipments — backend requires ROLE_PROSHIPADMIN + the STUCK_SHIPMENTS module (granted per user), so gate on the module. */}
          <Route
            path='ops/stuck-shipments'
            element={
              <MultiRoleProtectedRoute role={['STUCK_SHIPMENTS']}>
                <StuckShipments />
              </MultiRoleProtectedRoute>
            }
          />

          {/* Internal Alerts — backend requires ROLE_PROSHIPADMIN + the INTERNAL_ALERTS module (granted per user), so gate on the module. */}
          <Route
            path='alerts/internal'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL_ALERTS']}>
                <InternalAlerts />
              </MultiRoleProtectedRoute>
            }
          />

          <Route
            path='finance/reports/create'
            element={
              <ProtectedRoute role='REPORTS'>
                <CreateReport />
              </ProtectedRoute>
            }
          />
          <Route path='reports/create' element={<Navigate to='/finance/reports/create' replace />} />

          <Route
            path='finance/invoice-detail/:id/:merId'
            element={
              <ProtectedRoute role='FINANCE'>
                <InvoiceDetails />
              </ProtectedRoute>
            }
          />
          <Route path='invoice-detail/:id/:merId' element={<ProtectedRoute role='FINANCE'><InvoiceDetails /></ProtectedRoute>} />

          {/* ===================== Masters ===================== */}
          <Route
            path='masters/cod-remittance-all'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RemittanceForAllMerchant />
              </ProtectedRoute>
            }
          />
          <Route path='cod-remittance-for-all-merchant' element={<Navigate to='/masters/cod-remittance-all' replace />} />

          <Route
            path='masters/lost-damage'
            element={
              <ProtectedRoute role='INTERNAL'>
                <LostAndDamage />
              </ProtectedRoute>
            }
          />
          <Route path='lost-damage' element={<Navigate to='/masters/lost-damage' replace />} />

          <Route
            path='masters/credit-note'
            element={
              <ProtectedRoute role='INTERNAL'>
                <CreditNoteList />
              </ProtectedRoute>
            }
          />
          <Route path='credit-note' element={<Navigate to='/masters/credit-note' replace />} />

          <Route
            path='masters/merchant-invoice'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantInvoice />
              </ProtectedRoute>
            }
          />
          <Route path='merchant_invoice' element={<Navigate to='/masters/merchant-invoice' replace />} />

          <Route
            path='masters/cod-reconciliation'
            element={
              <ProtectedRoute role='INTERNAL'>
                <CODReconcilation />
              </ProtectedRoute>
            }
          />
          <Route path='cod-reconciliation' element={<Navigate to='/masters/cod-reconciliation' replace />} />

          <Route
            path='masters/merchant-wallet'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantWallet />
              </ProtectedRoute>
            }
          />

          <Route
            path='masters/merchant-transactions'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantTransaction />
              </ProtectedRoute>
            }
          />
          <Route path='merchant-transactions' element={<Navigate to='/masters/merchant-transactions' replace />} />

          <Route
            path='masters/notifications'
            element={
              <ProtectedRoute role='INTERNAL'>
                <Notification />
              </ProtectedRoute>
            }
          />
          <Route path='notification' element={<Navigate to='/masters/notifications' replace />} />

          <Route
            path='masters/insurance-order-status'
            element={
              <ProtectedRoute role='INTERNAL'>
                <InsuranceListTabs />
              </ProtectedRoute>
            }
          />
          <Route path='insurance-order-status' element={<Navigate to='/masters/insurance-order-status' replace />} />

          {/* ===================== Uploads ===================== */}
          <Route
            path='uploads/serviceability'
            element={
              <ProtectedRoute role='INTERNAL'>
                <UploadFiles />
              </ProtectedRoute>
            }
          />
          <Route path='uploads' element={<Navigate to='/uploads/serviceability' replace />} />

          <Route
            path='uploads/pods'
            element={
              <ProtectedRoute role='INTERNAL'>
                <PodsUploads />
              </ProtectedRoute>
            }
          />
          <Route path='pods-uploads' element={<Navigate to='/uploads/pods' replace />} />

          <Route
            path='uploads/bulk-status'
            element={
              <ProtectedRoute role='INTERNAL'>
                <BulkManualstatus />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-status-upload' element={<Navigate to='/uploads/bulk-status' replace />} />

          <Route
            path='uploads/edd'
            element={
              <ProtectedRoute role='INTERNAL'>
                <EddUploads />
              </ProtectedRoute>
            }
          />
          <Route path='edd-upload' element={<Navigate to='/uploads/edd' replace />} />

          <Route
            path='uploads/order-history'
            element={
              <ProtectedRoute role='INTERNAL'>
                <UpdateOrderHistory />
              </ProtectedRoute>
            }
          />
          <Route path='update-order-history' element={<Navigate to='/uploads/order-history' replace />} />

          <Route
            path='uploads/holiday-list'
            element={
              <ProtectedRoute role='INTERNAL'>
                <HolidayList />
              </ProtectedRoute>
            }
          />
          <Route path='upload-holiday-list' element={<Navigate to='/uploads/holiday-list' replace />} />

          {/* ===================== Users ===================== */}
          <Route
            path='users/management'
            element={
              <MultiRoleProtectedRoute role={['USER_SAVE', 'USER_RO', 'TOOLS']}>
                <UserManagementPanel />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='user-management' element={<Navigate to='/users/management' replace />} />

          <Route
            path='users/pii-access'
            element={
              <MultiRoleProtectedRoute role={['USER_SAVE', 'USER_RO', 'TOOLS']}>
                <UserLevelPiiAccess />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='user-level-pii-access' element={<Navigate to='/users/pii-access' replace />} />

          <Route
            path='users/audit-trails'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'MERCHANT_ADMIN']}>
                <AuditTrails />
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='audit-trails' element={<Navigate to='/users/audit-trails' replace />} />

          {/* ===================== Allocation ===================== */}
          <Route
            path='allocation/analytics'
            element={
              <ProtectedRoute role='SA'>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route path='allocation-analytics' element={<Navigate to='/allocation/analytics' replace />} />

          <Route
            path='allocation/all-shipments'
            element={
              <ProtectedRoute role='SA'>
                <AllShipmentsDetails />
              </ProtectedRoute>
            }
          />
          <Route path='all-shipments' element={<Navigate to='/allocation/all-shipments' replace />} />

          {/* ===================== Super Admin ===================== */}
          {/* RVP with QC — merchant-level QC configuration */}
          <Route
            path='admin/rvp-qc'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RvpQcSetups />
              </ProtectedRoute>
            }
          />
          <Route
            path='admin/rvp-qc/configure/:merchantId'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RvpQcEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path='admin/rvp-qc/master'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RvpQcMaster />
              </ProtectedRoute>
            }
          />
          <Route
            path='admin/rvp-qc/help'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RvpQcHelp />
              </ProtectedRoute>
            }
          />

          {/* ===================== KCI Event Tagging ===================== */}
          {/* Gated on the KCI_MANAGEMENT access module (KCI_API_DOC §1) — the same
              grant /api/kci/* enforces. A user without it can't reach these routes
              even by typing the URL, matching the sidebar visibility. */}
          <Route
            path='kci/events/create'
            element={
              <ProtectedRoute role='KCI_MANAGEMENT'>
                <CreateKciEvent />
              </ProtectedRoute>
            }
          />
          <Route
            path='kci/dashboard'
            element={
              <ProtectedRoute role='KCI_MANAGEMENT'>
                <KciDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='kci/events'
            element={
              <ProtectedRoute role='KCI_MANAGEMENT'>
                <ManageEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path='kci/tagged-orders'
            element={
              <ProtectedRoute role='KCI_MANAGEMENT'>
                <TaggedOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path='kci/notification-config'
            element={
              <ProtectedRoute role='KCI_MANAGEMENT'>
                <NotificationConfig />
              </ProtectedRoute>
            }
          />
          <Route
            path='admin/webhooks'
            element={
              <ProtectedRoute role='INTERNAL'>
                <WebHooks />
              </ProtectedRoute>
            }
          />
          <Route path='merchant-webhooks' element={<Navigate to='/admin/webhooks' replace />} />

          <Route
            path='admin/find-logs'
            element={
              <ProtectedRoute role='SA'>
                <ShippingLabel />
              </ProtectedRoute>
            }
          />
          <Route path='shipping-label' element={<Navigate to='/admin/find-logs' replace />} />

          <Route
            path='admin/bulk-cancellation'
            element={
              <ProtectedRoute role='SA'>
                <BulkCancellation />
              </ProtectedRoute>
            }
          />
          <Route path='bulk-cancellation' element={<Navigate to='/admin/bulk-cancellation' replace />} />

          <Route
            path='admin/merchant-config'
            element={
              <ProtectedRoute role='SA'>
                <MerchantConfig />
              </ProtectedRoute>
            }
          />
          <Route path='merchant-config' element={<Navigate to='/admin/merchant-config' replace />} />

          <Route
            path='admin/upload-file-refs'
            element={
              <ProtectedRoute role='SA'>
                <UploadFileRef />
              </ProtectedRoute>
            }
          />
          <Route path='upload-file-refs' element={<Navigate to='/admin/upload-file-refs' replace />} />


          <Route
            path='admin/update-merchant'
            element={
              <ProtectedRoute role='SA'>
                <UpdateMerchantName />
              </ProtectedRoute>
            }
          />
          <Route path='update-merchant-detail' element={<Navigate to='/admin/update-merchant' replace />} />

          <Route
            path='admin/notification-audit'
            element={
              <ProtectedRoute role='SA'>
                <NotificationAudit />
              </ProtectedRoute>
            }
          />
          <Route path='notify-content-audit' element={<Navigate to='/admin/notification-audit' replace />} />

          <Route
            path='admin/upload'
            element={
              <ProtectedRoute role='SA'>
                <Upload />
              </ProtectedRoute>
            }
          />
          <Route path='upload' element={<Navigate to='/admin/upload' replace />} />

          <Route
            path='admin/clear-cache'
            element={
              <ProtectedRoute role='SA'>
                <Cache />
              </ProtectedRoute>
            }
          />
          <Route path='cache' element={<Navigate to='/admin/clear-cache' replace />} />

          <Route
            path='admin/clear-wallet-cache'
            element={
              <ProtectedRoute role='SA'>
                <RefreshWallet />
              </ProtectedRoute>
            }
          />
          <Route path='clear-wallet-cache' element={<Navigate to='/admin/clear-wallet-cache' replace />} />

          <Route
            path='admin/zone-copy'
            element={
              <ProtectedRoute role='SA'>
                <CopyZone />
              </ProtectedRoute>
            }
          />
          <Route path='copy-zone' element={<Navigate to='/admin/zone-copy' replace />} />

          <Route
            path='admin/sy-config'
            element={
              <ProtectedRoute role='SA'>
                <SYConfig />
              </ProtectedRoute>
            }
          />
          <Route path='sy-config' element={<Navigate to='/admin/sy-config' replace />} />

          <Route
            path='admin/config'
            element={
              <ProtectedRoute role='SA'>
                <Config />
              </ProtectedRoute>
            }
          />
          <Route path='config' element={<Navigate to='/admin/config' replace />} />

          <Route
            path='admin/tracking-pages'
            element={
              <ProtectedRoute role='SA'>
                <TrackingPageAdmin />
              </ProtectedRoute>
            }
          />
          
          <Route path='whats-new' element={<ReleaseNotes />} />
          <Route path='whats-new/:id' element={<ReleaseNoteDetail />} />

          <Route
            path='admin/insurance-config'
            element={
              <ProtectedRoute role='SA'>
                <InsuranceConfig />
              </ProtectedRoute>
            }
          />
          <Route path='insurance-config' element={<Navigate to='/admin/insurance-config' replace />} />

          <Route
            path='admin/channel-config'
            element={
              <ProtectedRoute role='SA'>
                <ChannelConfig />
              </ProtectedRoute>
            }
          />
          <Route path='channel-config' element={<Navigate to='/admin/channel-config' replace />} />

          {/* ===================== Cross-cutting / Keep as-is ===================== */}
          <Route
            path='order-detail/:id'
            element={
              <MultiRoleProtectedRoute role={['B2C_ACCESS', 'PTL_ACCESS']}>
                <View />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='track'
            element={
              <ProtectedRoute role='INTERNAL'>
                <Tracking />
              </ProtectedRoute>
            }
          />
          <Route exact path='/tracking-list' element={<ListTracking />} />
          <Route exact path='/rate-calculator-ptl' element={<ShipmentRateCalculatorPTL />} />
          <Route
            path='update-edd'
            element={
              <ProtectedRoute role='B2C_ACCESS'>
                <UpdatedEdd />
              </ProtectedRoute>
            }
          />
          <Route
            path='qc-config'
            element={
              <ProtectedRoute role='SA'>
                <QcConfig />
              </ProtectedRoute>
            }
          />

          {/* ===================== Unmapped legacy routes kept as-is ===================== */}
          <Route
            path='users'
            element={
              <ProtectedRoute role='INTERNAL'>
                <MerchantUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path='rate-card'
            element={
              <ProtectedRoute role='INTERNAL'>
                <RateCard />
              </ProtectedRoute>
            }
          />
          <Route
            path='bulk-invoice-generate'
            element={
              <ProtectedRoute role='INTERNAL'>
                <InvoiceLabel />
              </ProtectedRoute>
            }
          />
          <Route
            path='courier-benchmarking'
            element={
              <ProtectedRoute role='DASHBOARD'>
                <CourierPerformance />
              </ProtectedRoute>
            }
          />

          {/* ===================== Claims (Non-E2E) ===================== */}
          <Route
            path='claims/all'
            element={
              <MultiRoleProtectedRoute role={['B2C_ACCESS', 'PTL_ACCESS', 'DASHBOARD', 'INTERNAL', 'TOOLS', 'NDR', 'WEIGHT_DESC', 'SA', 'AP_RESTRICTED']}>
                <AllClaims />
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='claims/:claimId'
            element={
              <MultiRoleProtectedRoute role={['B2C_ACCESS', 'PTL_ACCESS', 'DASHBOARD', 'INTERNAL', 'TOOLS', 'NDR', 'WEIGHT_DESC', 'SA', 'AP_RESTRICTED']}>
                <ClaimDetail />
              </MultiRoleProtectedRoute>
            }
          />

          {/* ===================== Release Notes ===================== */}
          <Route path='whats-new' element={<ReleaseNotes />} />
          <Route path='whats-new/:id' element={<ReleaseNoteDetail />} />

          {/* ===================== Supply-Side module (/supply/*) ===================== */}
          {/* Frontend-only, dummy-data; scoped theme/CSS via SupplySideLayout. */}
          {/* NOTE: Menu items for these routes are commented-out in menuConfig.js     */}
          {/*       until the supply module is signed off for master; the routes      */}
          {/*       below stay live so the pages remain reachable via direct URL.     */}
          <Route
            path='supply/partners'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PartnerDirectory />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/partners/onboard'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <OnboardWizard />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/partners/update'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <UpdateWizard />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/dashboard'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisDashboard />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/summary'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisHealthSummary />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/details'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisHealthDetails />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/manage'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisHealthManage />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/status-mapping'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisStatusMapping />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/cache'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisCacheManage />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/bluedart-origin-area'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisBlueDartOriginArea />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/error-mapping'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisErrorMapping />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/pcis-health/serviceability'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PcisServiceability />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/partners/:id'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <Partner360 />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/agreements'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyAgreements />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/rate-cards/d2c'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyRateCards vertical='D2C' />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/rate-cards/ptl'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyRateCards vertical='PTL' />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/zone-mapping'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyZoneMapper />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/zone-override'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyZoneOverride />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/invoice-recon'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyInvoiceRecon />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/payments'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyPayments />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/cod-recon'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyCodRecon />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/overcharge-errors'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyOvercharge />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/dashboard'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <SupplyDashboards />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/credentials'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <ClickpostSetup />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/courier-codes'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <CourierCodesMaster />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          {/* Payment Mode Compliance — Courier Performance → Payment Mode Compliance. Backend endpoint
              (/api/ops/payment-mode-guard) is ROLE_PROSHIPADMIN only with no separate module, so gate on the JWT role.
              Keeps SupplySideLayout because the page is built from the supply-side component kit (scoped theme/CSS). */}
          <Route
            path='courier-performance/payment-mode-compliance'
            element={
              <MultiRoleProtectedRoute role={['ROLE_PROSHIPADMIN']}>
                <SupplySideLayout>
                  <PaymentModeCompliance />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/codes/:code'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <CourierCodeDeepDive />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route
            path='supply/ptl'
            element={
              <MultiRoleProtectedRoute role={['INTERNAL', 'TOOLS', 'SA']}>
                <SupplySideLayout>
                  <PtlPlaceholder />
                </SupplySideLayout>
              </MultiRoleProtectedRoute>
            }
          />
          <Route path='supply' element={<Navigate to='/supply/partners' replace />} />

          {/* ===================== Intervention Analytics module (/intervention/*) ===================== */}
          <Route path='intervention/dashboard' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><InterventionDashboard /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/ndr' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><NdrDrilldown /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/npr' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><NprDrilldown /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/calls' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><CallAnalytics /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/calls/recordings' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><CallRecordings /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/whatsapp' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><WhatsappAnalytics /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/templates' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><TemplateRegistry /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/rules' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><RuleDashboard /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention/cost' element={<MultiRoleProtectedRoute role={['NDR', 'SA']}><InterventionLayout><CostAnalytics /></InterventionLayout></MultiRoleProtectedRoute>} />
          <Route path='intervention' element={<Navigate to='/intervention/dashboard' replace />} />

          {/* <Route path="unAuthorized" element={<UnAuthorized />} /> */}
          {/* <Route
                    exact
                    path="/update-payment-mode"
                    element={
                        <ProtectedRoute role="ORDERS">
                            <UpdateB2COrder />
                        </ProtectedRoute>
                    }
                /> */}
        </Route>
      </Routes>
    </>
  )
}
